import React, { useEffect, useState, useCallback, useRef } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { io } from 'socket.io-client';
import { useAuth } from '../contexts/AuthContext';
import EleicaoMesaVereador from '../components/EleicaoMesaVereador'; // PLENARIUM:ELEICAO_MESA
import { InicioCards, BarraSecao, TelaPresenca, GavetaOrdem, PresencaAoVivo, VotosNominais, AvisoResultado, CSS_CARDS, TelaSemSessaoCards, VoltarDoCelular, SessoesAnteriores, ConfirmarVoto, JustificarFalta, VotosDosVereadores } from '../components/PainelCards'; // PLENARIUM:CARDS -- v10 + PLENARIUM:JUSTIFICATIVA + PLENARIUM:VOTOS_AO_VIVO
import TodosProjetos from '../components/TodosProjetos'; // PLENARIUM:CARDS
import CentralDocumentos from '../components/CentralDocumentos'; // PLENARIUM:CENTRAL_DOCUMENTOS
import CronometroTablet from '../components/CronometroTablet'; // PLENARIUM:CRONOMETRO_TABLET
import LeiturasSecretario, { podeLer } from '../components/LeiturasSecretario'; // PLENARIUM:LEITURAS
// PLENARIUM:VEREADOR_ONLINE -- o login vai junto ao se identificar, para o admin ver quem esta conectado
const tokenOnline = () => { try { const h = (axios.defaults.headers.common && axios.defaults.headers.common.Authorization) || ''; return String(h).replace(/^Bearer\s+/i, '') || localStorage.getItem('token') || ''; } catch (e) { return ''; } };
import ComissoesVereador, { PareceresResumo } from '../components/ComissoesVereador'; // PLENARIUM:COMISSOES
import AtaVereador from '../components/AtaVereador'; // PLENARIUM:ATA_RETIFICACAO
import { MudarMeuVoto, AutorizarMudancaVoto } from '../components/MudancaVoto'; // PLENARIUM:MUDANCA_VOTO
import { TribunaVereador } from '../components/Tribuna'; // PLENARIUM:TRIBUNA
import { BotaoRoteiro } from '../components/RoteiroSessao'; // PLENARIUM:ROTEIRO_PRO
import { AvisoSegundaChamada } from '../components/Chamadas'; // PLENARIUM:DUAS_CHAMADAS
import { useNavigate } from 'react-router-dom';
import {
  LogOut, CheckCircle, XCircle, MinusCircle, Clock, KeyRound, X,
  FileText, Vote, Camera, ClipboardList, Plus, ChevronDown, ChevronUp,
  History, Calendar, Play, Square, Timer, Users, Crown, Mic, Sun, Moon,
  RefreshCw // PLENARIUM:RECARREGAR
} from 'lucide-react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { useEstruturaSessao, quorumDaCamara } from '../components/EstruturaSessao'; // PLENARIUM:QUORUM_CAMARA

const TIPO_LABEL = {
  PROJETO_LEI: 'Projeto de Lei', PROJETO_RESOLUCAO: 'Proj. Resolução',
  REQUERIMENTO: 'Requerimento', MOCAO: 'Moção', INDICACAO: 'Indicação', OUTROS: 'Outros',
  ATA_ANTERIOR: 'Ata da Sessão Anterior'
};
const ETAPA_LABEL = {
  RECEBIMENTO: { label: 'Recebimento', icon: '📥' }, COMISSAO: { label: 'Comissão', icon: '👥' },
  PLENARIO: { label: 'Plenário', icon: '🏛️' }, PROMULGADO: { label: 'Promulgado', icon: '✅' },
  ARQUIVADO: { label: 'Arquivado', icon: '📦' }, DEVOLVIDO: { label: 'Devolvido', icon: '↩️' },
};
const STATUS_COR   = { EM_TRAMITACAO: '#d97706', APROVADO: '#16a34a', REPROVADO: '#dc2626', ARQUIVADO: '#6b7280', DEVOLVIDO: '#dc2626', PROMULGADO: '#16a34a' };
const STATUS_BG    = { EM_TRAMITACAO: '#fef9c3', APROVADO: '#dcfce7', REPROVADO: '#fee2e2', ARQUIVADO: '#f3f4f6', DEVOLVIDO: '#fee2e2', PROMULGADO: '#dcfce7' };
const STATUS_LABEL = { EM_TRAMITACAO: 'Em Tramitação', APROVADO: 'Aprovado', REPROVADO: 'Reprovado', ARQUIVADO: 'Arquivado', DEVOLVIDO: 'Devolvido', PROMULGADO: 'Promulgado' };
const TIPOS_VEREADOR = ['REQUERIMENTO', 'MOCAO', 'INDICACAO', 'PROJETO_LEI', 'OUTROS'];
const VAZIO_REQ = { tipo: 'REQUERIMENTO', ementa: '', descricao: '', arquivoUrl: '' };

// ══════════════════════════════════════════
// BOTTOM BAR MOBILE
// ══════════════════════════════════════════

// ── Nome exibido nas telas ──────────────────────────────────────────
// Usa o nome parlamentar quando houver. Documentos oficiais (ata, lista
// de presença, relatórios) continuam usando SEMPRE o nome civil.
const exib = (v) => (v && (v.nomeParlamentar || v.nome)) || '';
const exibCurto = (v) => {
  if (!v) return '';
  if (v.nomeParlamentar) return v.nomeParlamentar;
  const p = String(v.nome || '').trim().split(/\s+/);
  return p.length > 1 ? p[0] + ' ' + p[p.length - 1] : (p[0] || '');
};
// O socket envia o nome CIVIL do orador; aqui só descobrimos como exibi-lo.
const exibPorNome = (lista, nome) => {
  const achado = (lista || []).find(x => x.nome === nome);
  return (achado && achado.nomeParlamentar) || nome || '';
};

// >>> PLENARIUM:VOTACAO_BLOCO -- lista das materias de uma votacao em bloco
function ListaBloco({ itens }) {
  return (
    <div style={{ width: '100%' }}>
      <p style={{ fontSize: '.9rem', fontWeight: 700, color: '#475569', margin: '0 0 8px' }}>Um voto só vale para todas estas matérias:</p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: '34vh', overflowY: 'auto' }}>
        {itens.map((p, i) => (
          <div key={p.id} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', padding: '8px 10px', borderRadius: 10, background: '#f1f5f9', border: '1px solid #e2e8f0' }}>
            <span style={{ flex: '0 0 auto', minWidth: 24, height: 24, borderRadius: 999, background: '#1e3a8a', color: '#fff', fontSize: '.75rem', fontWeight: 800, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>{i + 1}</span>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: '.78rem', fontWeight: 800, color: '#1e3a8a' }}>{TIPO_LABEL[p.tipo] || p.tipo} · {p.numero}</div>
              <div style={{ fontSize: '.95rem', fontWeight: 600, color: '#0f172a', lineHeight: 1.3, overflowWrap: 'anywhere' }}>{p.titulo}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
// <<< PLENARIUM:VOTACAO_BLOCO

// ── Tratamento do parlamentar ───────────────────────────────────────
// "Presidente" e "Vice-Presidente" NAO variam com o sexo (decisão da casa).
// Sem sexo cadastrado, mantém "Vereador", que era o comportamento anterior.
const tratamento = (v) => {
  if (!v) return 'Vereador';
  if (v.cargo === 'PRESIDENTE') return 'Presidente';
  if (v.cargo === 'VICE_PRESIDENTE') return 'Vice-Presidente';
  return v.sexo === 'F' ? 'Vereadora' : 'Vereador';
};

// ── Confirmação de presença pelo próprio vereador ────────────────────
// Aparece só enquanto o vereador ainda não tem presença nesta sessão.
// Depois de confirmar, vira uma faixa discreta e o botão some.
function CartaoPresenca({ sessaoId }) {
  const [estado, setEstado] = useState('carregando');
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    let vivo = true;
    if (!sessaoId) { setEstado('sem-sessao'); return; }
    axios.get(`/api/presencas/minha/${sessaoId}`)
      .then(r => { if (vivo) setEstado(r.data?.presente ? 'presente' : 'ausente'); })
      .catch(() => { if (vivo) setEstado('ausente'); });
    const confirmou = () => { if (vivo) setEstado('presente'); }; // PLENARIUM:CARDS
    window.addEventListener('plenarium:presenca', confirmou);
    return () => { vivo = false; window.removeEventListener('plenarium:presenca', confirmou); };
  }, [sessaoId]);

  const confirmar = async () => {
    setEnviando(true);
    try {
      await axios.post(`/api/presencas/confirmar/${sessaoId}`);
      setEstado('presente');
      toast.success('Presença confirmada!');
    } catch (e) {
      toast.error(e?.response?.data?.error || 'Não foi possível confirmar a presença');
    } finally {
      setEnviando(false);
    }
  };

  if (estado === 'carregando' || estado === 'sem-sessao') return null;

  if (estado === 'presente') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#dcfce7', border: '1px solid #bbf7d0', borderRadius: 10, padding: '10px 14px', marginBottom: 12 }}>
        <CheckCircle size={17} color="#15803d" />
        <span style={{ fontSize: '0.984rem', color: '#15803d', fontWeight: 700 }}>Presença registrada nesta sessão</span>
      </div>
    );
  }

  return (
    <div style={{ background: 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)', borderRadius: 14, padding: '18px 20px', marginBottom: 14, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap', boxShadow: '0 4px 14px rgba(37,99,235,0.25)' }}>
      <div style={{ minWidth: 0 }}>
        <p style={{ margin: '0 0 3px', color: 'white', fontWeight: 800, fontSize: '1.14rem' }}>Registre sua presença</p>
        <p style={{ margin: 0, color: 'rgba(255,255,255,0.85)', fontSize: '0.936rem' }}>A sessão está aberta. Confirme para constar na lista de presença.</p>
      </div>
      <button
        onClick={confirmar}
        disabled={enviando}
        style={{ background: 'white', color: '#1d4ed8', border: 'none', borderRadius: 10, padding: '12px 22px', fontSize: '1.056rem', fontWeight: 800, cursor: enviando ? 'wait' : 'pointer', display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0, opacity: enviando ? 0.7 : 1 }}
      >
        <CheckCircle size={17} />
        {enviando ? 'Confirmando...' : 'Confirmar minha presença'}
      </button>
    </div>
  );
}

function BottomBarMobile({ aba, setAba, isPresidente, pautaAtiva, cronometroAtivo, pautasPendentes, sessao, onCronometro, onSenha, onLogout }) {
  const itens = [
    { id: 'votacao',      icon: <Vote size={20} />,        label: 'Votação',    badge: !!pautaAtiva },
    { id: 'ordem',        icon: <Calendar size={20} />,    label: 'Ordem'  },
    { id: 'historico',    icon: <History size={20} />,     label: 'Sessões' },
    { id: 'projetos',     icon: <FileText size={20} />,    label: 'Projetos' },
    { id: 'requerimento', icon: <Plus size={20} />,        label: 'Requerer' },
  ];

  if (isPresidente) {
    itens.push(
      { id: 'controle', icon: <Play size={20} />, label: 'Controle', badge: sessao && pautasPendentes?.length > 0, cor: '#dc2626' },
      // cronometro removido do acesso do presidente — operado somente pelo admin
    );
  }

  // item Sair sempre no final
  const sairItem = { id: 'sair', icon: <LogOut size={20} />, label: 'Sair', isAction: true, action: onLogout };
  // PLENARIUM:RECARREGAR -- recarrega a tela. Seguro: ao abrir de novo o
  // painel pergunta ao servidor se ha votacao aberta e se ja votou.
  const recarregarItem = { id: 'recarregar', icon: <RefreshCw size={20} />, label: 'Atualizar', isAction: true, action: () => window.location.reload() };
  const todosItens = [...itens, recarregarItem, sairItem];

  return (
    <nav style={{
      display: 'none',
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000,
      background: '#0f172a',
      borderTop: '1px solid rgba(255,255,255,0.1)',
      padding: '6px 0 calc(6px + env(safe-area-inset-bottom))',
    }} className="pv-bottom-bar">
      {todosItens.map(item => {
        const ativo = !item.isAction && aba === item.id;
        const cor = item.cor || '#2563eb';
        return (
          <button
            key={item.id}
            onClick={() => item.isAction ? item.action() : setAba(item.id)}
            style={{
              flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
              justifyContent: 'center', gap: 3, padding: '4px 2px',
              background: 'none', border: 'none', cursor: 'pointer',
              color: ativo ? cor : item.id === 'sair' ? '#ef4444' : 'rgba(255,255,255,0.45)',
              position: 'relative', minWidth: 0,
              transition: 'color 0.15s',
            }}
          >
            {/* Indicador ativo */}
            {ativo && (
              <div style={{
                position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)',
                width: 28, height: 2, borderRadius: 2, background: cor,
              }} />
            )}
            {/* Badge ponto vermelho */}
            {item.badge && (
              <div style={{
                position: 'absolute', top: 4, right: '50%', marginRight: -16,
                width: 7, height: 7, borderRadius: '50%',
                background: '#ef4444', border: '1.5px solid #0f172a',
              }} />
            )}
            <div style={{ color: 'inherit' }}>{item.icon}</div>
            <span style={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: 0.2, lineHeight: 1 }}>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

function Bloco({ icon, label, ativo, badge, onClick, cor = '#1a2d5a', destaque = false }) {
  return (
    <button onClick={onClick} style={{
      flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', gap: 8, padding: '16px 8px',
      background: ativo ? cor : destaque ? `${cor}12` : 'white',
      border: `2px solid ${ativo ? cor : destaque ? cor : '#e2e8f0'}`,
      borderRadius: 12, cursor: 'pointer', transition: 'all 0.18s', position: 'relative',
      boxShadow: ativo ? `0 4px 16px ${cor}44` : '0 1px 4px rgba(0,0,0,0.05)',
    }}>
      <div style={{ width: 42, height: 42, borderRadius: 11, background: ativo ? 'rgba(255,255,255,0.2)' : `${cor}20`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: ativo ? 'white' : cor }}>{icon}</div>
      <span style={{ fontSize: '0.864rem', fontWeight: 700, lineHeight: 1.2, textAlign: 'center', color: ativo ? 'white' : '#1e293b' }}>{label}</span>
      {badge && <span style={{ position: 'absolute', top: 6, right: 6, width: 10, height: 10, borderRadius: '50%', background: '#ef4444', border: '2px solid white', animation: 'pulse 1.4s ease infinite' }} />}
    </button>
  );
}

export default function PainelVereador() {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();
  const isPresidente = usuario?.cargo === 'PRESIDENTE';

  const [aba, setAba] = useState('inicio'); // PLENARIUM:CARDS v6 -- ao entrar, os cards
  const [verOrdem, setVerOrdem] = useState(false); // PLENARIUM:CARDS -- Ordem do Dia por cima da Votacao
  const [sessao, setSessao] = useState(null);
  const [pautaAtiva, setPautaAtiva] = useState(null);
  const [pautas, setPautas] = useState([]);
  const [jaVotou, setJaVotou] = useState(false);
  const estruturaPV = useEstruturaSessao(); // PLENARIUM:QUORUM_CAMARA
  const [chamada2PV, setChamada2PV] = useState(null); // PLENARIUM:QUORUM_AJUSTE -- 2a chamada usa o quorum de votacao
  const [meuVoto, setMeuVoto] = useState(null);
  const [votando, setVotando] = useState(false);
  const [loading, setLoading] = useState(true);
  const [confirmando, setConfirmando] = useState(null);
  const [modalSenha, setModalSenha] = useState(false);
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [salvandoSenha, setSalvandoSenha] = useState(false);
  const [modalFoto, setModalFoto] = useState(false);
  const [novaFoto, setNovaFoto] = useState('');
  const [salvandoFoto, setSalvandoFoto] = useState(false);
  const [fotoAtual, setFotoAtual] = useState(usuario?.fotoUrl || '');
  // PLENARIUM:LEITURAS -- cargo atual vindo do banco (o do login pode estar antigo)
  const [cargoReal, setCargoReal] = useState(null);
  useEffect(() => {
    if (!usuario?.id) return undefined;
    let vivo = true;
    axios.get(`/api/vereadores/${usuario.id}`).then(r => { if (vivo && r.data) setCargoReal(r.data.cargo || null); }).catch(() => {});
    return () => { vivo = false; };
  }, [usuario?.id]);
  const mostraLeituras = podeLer(cargoReal || usuario?.cargo);
  // PLENARIUM:COMISSOES -- o card "Comissoes" so aparece para quem integra comissao
  const [infoComissoes, setInfoComissoes] = useState(null);
  useEffect(() => {
    if (!usuario?.id) return undefined;
    let vivo = true;
    const ler = () => axios.get('/api/comissoes/minhas').then(r => {
      if (!vivo || !r.data) return;
      const d = r.data;
      const pend = (d.documentosNovos || 0) /* PLENARIUM:PROTOCOLO_COMISSOES */ + (d.relatorias || []).length + (d.paraVotar || []).filter(x => !x.meuVoto && !x.souRelator).length + (d.presidir || []).filter(x => x.status === 'AGUARDANDO_RELATOR').length;
      setInfoComissoes(d.membro ? { pendentes: pend } : null);
    }).catch(() => {});
    ler();
    const t = setInterval(ler, 120000);
    return () => { vivo = false; clearInterval(t); };
  }, [usuario?.id]);
  const [meusProjetos, setMeusProjetos] = useState([]);
  const [meusDiscursos, setMeusDiscursos] = useState([]);
  const [loadingProjetos, setLoadingProjetos] = useState(false);
  const [expandidoProjeto, setExpandidoProjeto] = useState(null);
  const [filtroProjeto, setFiltroProjeto] = useState('TODOS');
  const [formReq, setFormReq] = useState(VAZIO_REQ);
  const [salvandoReq, setSalvandoReq] = useState(false);
  const [historico, setHistorico] = useState([]);
  const [loadingHistorico, setLoadingHistorico] = useState(false);
  const [expandidoSessao, setExpandidoSessao] = useState(null);
  const [cronometroSocket, setCronometroSocket] = useState(null);

  const [presencas, setPresencas] = useState([]);
  const [contagemRT, setContagemRT] = useState({ SIM: 0, NAO: 0, ABSTENCAO: 0, TOTAL: 0 });
  const [loadingPresenca, setLoadingPresenca] = useState(false);
  const [vereadores, setVereadores] = useState([]);
  const [modalCronometro, setModalCronometro] = useState(false);
  const [nomeOrador, setNomeOrador] = useState('');
  const [fotoOrador, setFotoOrador] = useState('');
  const [tempoOrador, setTempoOrador] = useState(3);
  const [vereadorSelecionado, setVereadorSelecionado] = useState('');
  const [cronometroAtivo, setCronometroAtivo] = useState(false);
  // Fila de oradores
  const [filaOradores, setFilaOradores] = useState([]);
  const [abaFila, setAbaFila] = useState('vereadores'); // 'vereadores' | 'fila' | 'externo'
  const [nomeExterno, setNomeExterno] = useState('');
  const [tempoExterno, setTempoExterno] = useState(3);
  const [modoClaro, setModoClaro] = useState(() => localStorage.getItem('pv-modo') === 'claro');
  const [tempoRestante, setTempoRestante] = useState(0);
  const [cronometroPausado, setCronometroPausado] = useState(false);
  const intervalRef = useRef(null);
  const socketRef = useRef(null);
  const sessaoIdRef = useRef(null); // PLENARIUM:RECONECTAR_SESSAO
  const cronSocketIntervalRef = useRef(null);
  const cronUltimoRef = useRef(0); // PLENARIUM:RESSINCRONIZAR -- hora do ultimo aviso do cronometro

  useEffect(() => {
    if (modoClaro) {
      document.documentElement.setAttribute('data-pv-modo', 'claro');
      localStorage.setItem('pv-modo', 'claro');
    } else {
      document.documentElement.removeAttribute('data-pv-modo');
      localStorage.setItem('pv-modo', 'escuro');
    }
  }, [modoClaro]);

  const buscarSessao = useCallback(async () => {
    try {
      const camaraId = usuario?.camaraId;
      const r = await axios.get(`/api/sessoes/em-andamento${camaraId ? `?camaraId=${camaraId}` : ''}`);
      setSessao(r.data);
      if (r.data) {
        const ord = [...(r.data.pautas || [])].sort((a, b) => a.ordem - b.ordem);
        setPautas(ord);
        const ativa = ord.find(p => p.status === 'EM_VOTACAO') || null;
        setPautaAtiva(ativa);
        if (ativa) {
          const vRes = await axios.get(`/api/votacao/verificar/${ativa.id}`);
          setJaVotou(vRes.data.jaVotou);
          setMeuVoto(vRes.data.opcao);
        } else { setJaVotou(false); setMeuVoto(null); }
      // Buscar presenças reais da sessão
      if (r.data?.id) {
        try {
          const pRes = await axios.get(`/api/relatorios/sessao/${r.data.id}`);
          setPresencas(pRes.data.presenca || []); setChamada2PV(pRes.data.segundaChamada || null);
        } catch { setPresencas([]); }
      }
      } else { setPautas([]); }
    } catch {}
    finally { setLoading(false); }
  }, [usuario?.camaraId]);

  const buscarMeusProjetos = useCallback(async () => {
    setLoadingProjetos(true);
    try {
      const [projRes, discRes] = await Promise.all([
        axios.get('/api/projetos/meus'),
        axios.get('/api/uso-palavra/meus').catch(() => ({ data: [] }))
      ]);
      setMeusProjetos(projRes.data);
      setMeusDiscursos(discRes.data);
    }
    catch { toast.error('Erro ao carregar projetos'); }
    finally { setLoadingProjetos(false); }
  }, []);

  const buscarHistorico = useCallback(async () => {
    setLoadingHistorico(true);
    try { const r = await axios.get('/api/relatorios/geral'); setHistorico(r.data.sessoes || []); }
    catch { toast.error('Erro ao carregar histórico'); }
    finally { setLoadingHistorico(false); }
  }, []);

  const buscarPresenca = useCallback(async () => {
    if (!sessao?.id) return;
    setLoadingPresenca(true);
    try {
      const [relRes, vRes] = await Promise.all([
        axios.get(`/api/relatorios/sessao/${sessao.id}`),
        axios.get('/api/vereadores')
      ]);
      setPresencas(relRes.data.presenca || []); setChamada2PV(relRes.data.segundaChamada || null);
      setVereadores(vRes.data.filter(v => v.ativo));
    } catch { toast.error('Erro ao carregar presenças'); }
    finally { setLoadingPresenca(false); }
  }, [sessao?.id]);

  useEffect(() => {
    buscarSessao();
    // Carregar vereadores imediatamente para exibir PRESENTES e QUÓRUM
    axios.get('/api/vereadores').then(r => setVereadores(r.data.filter(v => v.ativo))).catch(() => {});
    const socket = io(process.env.REACT_APP_API_URL || 'http://localhost:3001');
    socketRef.current = socket;
    // Entrar na sala da câmara para receber eventos mesmo sem sessão ativa
    const camaraId = usuario?.camaraId;
    if (camaraId) socket.emit('entrar-sala', `camara-${camaraId}`);
    // Diz ao Painel do Servidor quem está com o painel aberto.
    // >>> PLENARIUM:RECONECTAR
    // A cada (re)conexao entra de novo na sala da camara: depois de uma
    // queda de internet o servidor ve uma conexao nova, fora da sala, e o
    // tablet deixava de receber os avisos da sessao. Na RECONEXAO busca
    // tambem o estado da sessao (votacao aberta, se ja votou, placar).
    let primeiraConexao = true;
    // >>> PLENARIUM:RESSINCRONIZAR
    // Quando a internet volta (ou o tablet acorda), faz sozinho o mesmo que
    // o botao Atualizar: busca de novo a sessao, a votacao e o cronometro,
    // sem recarregar a pagina (recarregar com a rede ainda instavel pode
    // deixar o tablet numa tela de erro). Se o cronometro acabou durante a
    // queda, o servidor nao responde nada: em 3s sem aviso ele sai da tela.
    let limparCrono = null;
    const ressincronizar = () => {
      if (camaraId) socket.emit('entrar-sala', `camara-${camaraId}`);
      if (sessaoIdRef.current) {
        socket.emit('entrar-sala', `sessao-${sessaoIdRef.current}`);
        const pedido = Date.now();
        socket.emit('cronometro-sync', { sessaoId: sessaoIdRef.current }); // PLENARIUM:CRONO_SYNC
        if (limparCrono) clearTimeout(limparCrono);
        limparCrono = setTimeout(() => {
          if (cronUltimoRef.current < pedido) {
            if (cronSocketIntervalRef.current) clearInterval(cronSocketIntervalRef.current);
            setCronometroSocket(null);
          }
        }, 3000);
      }
      buscarSessao();
    };
    socket.on('connect', () => {
      socket.emit('identificar', { tipo: 'vereador', nome: usuario?.nome || 'Vereador', token: tokenOnline() });
      if (camaraId) socket.emit('entrar-sala', `camara-${camaraId}`);
      // PLENARIUM:RECONECTAR_SESSAO -- volta tambem para a sala da sessao
      if (sessaoIdRef.current) socket.emit('entrar-sala', `sessao-${sessaoIdRef.current}`);
      if (primeiraConexao) { if (sessaoIdRef.current) socket.emit('cronometro-sync', { sessaoId: sessaoIdRef.current }); }
      else ressincronizar();
      primeiraConexao = false;
    });
    // Internet voltou: reconecta na hora, sem esperar a proxima tentativa.
    const aoVoltarInternet = () => { if (!socket.connected) socket.connect(); else ressincronizar(); };
    // Tablet acordou / app voltou para a frente: pode ter perdido avisos.
    const aoVoltarTela = () => { if (document.visibilityState !== 'visible') return; if (!socket.connected) socket.connect(); else ressincronizar(); };
    window.addEventListener('online', aoVoltarInternet);
    document.addEventListener('visibilitychange', aoVoltarTela);
    // <<< PLENARIUM:RESSINCRONIZAR
    // <<< PLENARIUM:RECONECTAR
    socket.emit('identificar', { tipo: 'vereador', nome: usuario?.nome || 'Vereador', token: tokenOnline() });
    socket.on('pauta-iniciada', (p) => {
      setPautaAtiva(p);
      // PLENARIUM:VOTACAO_BLOCO -- marca tambem as outras materias do bloco
      const idsBloco = new Set((p.bloco || []).map(b => b.id));
      setPautas(prev => prev.map(x => x.id === p.id ? { ...x, status: 'EM_VOTACAO', blocoId: p.blocoId || null } : idsBloco.has(x.id) ? { ...x, blocoId: p.id } : x));
      setJaVotou(false); setMeuVoto(null); setAba('votacao');
      setContagemRT({ SIM: 0, NAO: 0, ABSTENCAO: 0, TOTAL: 0 });
      toast('🗳️ Nova votação iniciada!', { icon: '📋' });
    });
    socket.on('pauta-encerrada', (p) => {
      setPautaAtiva(null);
      // PLENARIUM:VOTACAO_BLOCO -- o resultado vale para as outras materias do bloco
      const blocoEnc = {}; (p.bloco || []).forEach(b => { blocoEnc[b.id] = b; });
      setPautas(prev => prev.map(x => x.id === p.id ? { ...x, status: p.status, votos: p.votos } : blocoEnc[x.id] ? { ...x, status: blocoEnc[x.id].status, votos: blocoEnc[x.id].votos, blocoId: p.id } : x));
      setJaVotou(false); setMeuVoto(null);
      toast('Votação encerrada', { icon: '✅' });
    });
    // Presenca de qualquer vereador mudou (a propria, a de um colega, ou
    // marcacao pelo admin): recarrega para o contador e o quorum refletirem.
    socket.on('presenca-atualizada', () => { buscarSessao(); });
    socket.on('bloco-atualizado', () => { buscarSessao(); toast('Uma matéria saiu do bloco e será votada separadamente.', { icon: '📌' }); }); // PLENARIUM:VOTO_MESA -- destaque
    socket.on('sessao-atualizada', (s) => {
      if (s.status === 'ENCERRADA') { setSessao(null); setPautas([]); toast('Sessão encerrada', { icon: '🏛️' }); }
      else if (s.status === 'EM_ANDAMENTO') { buscarSessao(); toast('Sessão iniciada!', { icon: '🏛️' }); }
    });
    socket.on('novo-voto', (data) => {
      // PLENARIUM:SEGURANCA -- secreta: chega so quantos ja votaram
      if (data.votacaoSecreta) { setContagemRT({ SIM: 0, NAO: 0, ABSTENCAO: 0, TOTAL: data.totalVotos || 0 }); return; }
      if (data.contagem) {
        const cnt = { SIM: 0, NAO: 0, ABSTENCAO: 0, TOTAL: 0 };
        data.contagem.forEach(c => { cnt[c.opcao] = c._count.opcao; });
        cnt.TOTAL = cnt.SIM + cnt.NAO + cnt.ABSTENCAO;
        setContagemRT(cnt);
      }
    });
    socket.on('cronometro-update', (data) => {
      cronUltimoRef.current = Date.now(); // PLENARIUM:RESSINCRONIZAR
      if (data.encerrado) {
        if (cronSocketIntervalRef.current) clearInterval(cronSocketIntervalRef.current);
        setCronometroSocket(null);
      } else if (data.pausado) {
        if (cronSocketIntervalRef.current) clearInterval(cronSocketIntervalRef.current);
        setCronometroSocket(data);
      } else {
        setCronometroSocket(data);
        if (cronSocketIntervalRef.current) clearInterval(cronSocketIntervalRef.current);
        cronSocketIntervalRef.current = setInterval(() => {
          setCronometroSocket(prev => {
            if (!prev) return prev;
            if (prev.tempo <= 1) { clearInterval(cronSocketIntervalRef.current); return { ...prev, tempo: 0 }; }
            return { ...prev, tempo: prev.tempo - 1 };
          });
        }, 1000);
      }
    });
    return () => { window.removeEventListener('online', aoVoltarInternet); document.removeEventListener('visibilitychange', aoVoltarTela); if (limparCrono) clearTimeout(limparCrono); socket.disconnect(); if (cronSocketIntervalRef.current) clearInterval(cronSocketIntervalRef.current); };
  }, [buscarSessao]);

  useEffect(() => { sessaoIdRef.current = sessao?.id || null; /* PLENARIUM:RECONECTAR_SESSAO */ if (sessao?.id && socketRef.current) { socketRef.current.emit('entrar-sala', `sessao-${sessao.id}`); socketRef.current.emit('cronometro-sync', { sessaoId: sessao.id }); /* PLENARIUM:CRONO_SYNC */ } }, [sessao?.id]);

  // Garante entrada na sala da câmara mesmo se camaraId demorar a estar disponível
  useEffect(() => {
    if (usuario?.camaraId && socketRef.current) {
      socketRef.current.emit('entrar-sala', `camara-${usuario.camaraId}`);
    }
  }, [usuario?.camaraId]);

  useEffect(() => {
    if (aba === 'projetos') buscarMeusProjetos();
    if (aba === 'historico') buscarHistorico();
    if (aba === 'presenca') buscarPresenca();
  }, [aba, buscarMeusProjetos, buscarHistorico, buscarPresenca]);

  // Carrega historico e projetos na montagem para exibir na tela inicial
  useEffect(() => {
    buscarHistorico();
    buscarMeusProjetos();
  }, [buscarHistorico, buscarMeusProjetos]);

  useEffect(() => {
    if (cronometroAtivo && !cronometroPausado && tempoRestante > 0) {
      intervalRef.current = setInterval(() => {
        setTempoRestante(prev => {
          if (prev <= 1) {
            clearInterval(intervalRef.current); setCronometroAtivo(false);
            toast('⏰ Tempo do orador encerrado!', { duration: 5000 });
            socketRef.current?.emit('cronometro-update', { sessaoId: sessao?.id, tempo: 0, nome: nomeOrador, foto: fotoOrador, encerrado: true });
            // Registrar uso da palavra no banco
            if (sessao?.id && nomeOrador) {
              const tempoUsado = tempoOrador * 60;
              const vId = vereadores.find(v => v.nome === nomeOrador)?.id || null;
              const part = vereadores.find(v => v.nome === nomeOrador)?.partido || null;
              axios.post('/api/uso-palavra', {
                sessaoId: sessao.id,
                vereadorId: vId,
                nome: nomeOrador,
                partido: part,
                tempoTotal: tempoUsado
              }).catch(() => {});
            }
            // Som de encerramento
            try {
              const ctx = new (window.AudioContext || window.webkitAudioContext)();
              const osc = ctx.createOscillator();
              const gain = ctx.createGain();
              osc.connect(gain); gain.connect(ctx.destination);
              osc.frequency.setValueAtTime(880, ctx.currentTime);
              osc.frequency.setValueAtTime(660, ctx.currentTime + 0.15);
              osc.frequency.setValueAtTime(440, ctx.currentTime + 0.3);
              gain.gain.setValueAtTime(0.6, ctx.currentTime);
              gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.6);
              osc.start(ctx.currentTime); osc.stop(ctx.currentTime + 0.6);
            } catch(e) {}
            return 0;
          }
          const novo = prev - 1;
          return novo;
        });
      }, 1000);
    }
    return () => clearInterval(intervalRef.current);
  }, [cronometroAtivo, cronometroPausado, sessao?.id, nomeOrador, fotoOrador]);

  const adicionarTempo = (seg) => {
    setTempoRestante(prev => {
      const novo = prev + seg;
      socketRef.current?.emit('cronometro-update', { sessaoId: sessao?.id, tempo: novo, nome: nomeOrador, foto: fotoOrador, encerrado: false });
      return novo;
    });
    toast.success(`+${seg >= 60 ? `${seg / 60}min` : `${seg}s`} adicionado!`);
  };

  // ── Funções de fila de oradores ──
  const adicionarNaFila = (vereador) => {
    setFilaOradores(prev => [...prev, {
      id: Date.now() + Math.random(),
      nome: vereador.nome,
      partido: vereador.partido,
      foto: vereador.fotoUrl || '',
      vereadorId: vereador.id,
      tempo: 3,
    }]);
    setAbaFila('fila');
  };

  const adicionarExternoNaFila = () => {
    if (!nomeExterno.trim()) { toast.error('Informe o nome do orador.'); return; }
    setFilaOradores(prev => [...prev, {
      id: Date.now() + Math.random(),
      nome: nomeExterno.trim(),
      partido: 'Externo',
      foto: '',
      vereadorId: null,
      tempo: tempoExterno,
    }]);
    setNomeExterno('');
    setAbaFila('fila');
    toast.success('Orador externo adicionado à fila!');
  };

  const removerDaFila = (id) => setFilaOradores(prev => prev.filter(f => f.id !== id));

  const moverFila = (id, direcao) => {
    setFilaOradores(prev => {
      const idx = prev.findIndex(f => f.id === id);
      if (idx < 0) return prev;
      const novo = [...prev];
      const destino = idx + direcao;
      if (destino < 0 || destino >= novo.length) return prev;
      [novo[idx], novo[destino]] = [novo[destino], novo[idx]];
      return novo;
    });
  };

  const atualizarTempoFila = (id, tempo) => {
    setFilaOradores(prev => prev.map(f => f.id === id ? { ...f, tempo: Number(tempo) } : f));
  };

  const iniciarDaFila = (item) => {
    const segundos = item.tempo * 60;
    setNomeOrador(item.nome);
    setFotoOrador(item.foto || '');
    setTempoOrador(item.tempo);
    setVereadorSelecionado(item.vereadorId || '');
    setTempoRestante(segundos);
    setCronometroAtivo(true);
    setCronometroPausado(false);
    setModalCronometro(false);
    removerDaFila(item.id);
    socketRef.current?.emit('cronometro-update', {
      sessaoId: sessao?.id,
      tempo: segundos,
      tempoTotal: segundos,
      nome: item.nome,
      foto: item.foto,
      encerrado: false,
      iniciado: true,
    });
    toast.success(`Cronômetro iniciado para ${item.nome}!`);
  };

  const votar = (opcao) => { if (!pautaAtiva || jaVotou || votando) return; if (meuVoto && opcao === meuVoto) { setJaVotou(true); return; } setConfirmando(opcao); }; // PLENARIUM:TROCA_VOTO -- mesmo voto: so volta

  const confirmarVoto = async () => {
    if (!confirmando) return; setVotando(true);
    try {
      await axios.post('/api/votacao', { pautaId: pautaAtiva.id, opcao: confirmando });
      const eraTroca = !!meuVoto; setJaVotou(true); setMeuVoto(confirmando); toast.success(eraTroca ? 'Voto alterado!' : 'Voto registrado!'); // PLENARIUM:TROCA_VOTO (PLENARIUM:TV_SOBERANA)
    } catch (err) { toast.error(err.response?.data?.error || 'Erro ao votar'); }
    finally { setVotando(false); setConfirmando(null); }
  };

  const iniciarVotacao = async (pautaId) => {
    try { await axios.patch(`/api/pautas/${pautaId}/iniciar`); toast.success('Votação iniciada!'); }
    catch (err) { toast.error(err.response?.data?.error || 'Erro ao iniciar votação'); }
  };

  const encerrarVotacao = async (pauta) => {
    // >>> PLENARIUM:SEGURANCA -- votacao secreta: a tela nao conhece o placar;
    // o sistema apura o resultado ao encerrar.
    if (pauta.votacaoSecreta) {
      let nVotos = pauta.totalVotos || 0;
      try { const pr = await axios.get(`/api/pautas/sessao/${sessao?.id}`); const pa = pr.data.find(p => p.id === pauta.id); if (pa && typeof pa.totalVotos === 'number') nVotos = pa.totalVotos; } catch {}
      const aviso = nVotos < totalPresentes ? `⚠️ ATENÇÃO: Apenas ${nVotos} de ${totalPresentes} vereador(es) presente(s) votaram.\n\n` : '';
      if (!window.confirm(`${aviso}Votação secreta: ${nVotos} voto(s) registrado(s). O resultado será apurado pelo sistema ao encerrar.\n\nEncerrar a votação?`)) return;
      try {
        const r = await axios.patch(`/api/pautas/${pauta.id}/encerrar`, { resultado: 'APROVADA' });
        toast.success(`Pauta ${r.data?.status === 'APROVADA' ? '✅ Aprovada' : '❌ Reprovada'}!`);
      } catch { toast.error('Erro ao encerrar votação'); }
      return;
    }
    // <<< PLENARIUM:SEGURANCA
    // Buscar votos frescos da API para garantir contagem correta
    let votosAtuais = pauta.votos || [];
    try {
      const pRes = await axios.get(`/api/pautas/sessao/${sessao?.id}`);
      const pautaAtual = pRes.data.find(p => p.id === pauta.id);
      if (pautaAtual?.votos) votosAtuais = pautaAtual.votos;
    } catch {}
    const sim = votosAtuais.filter(v => v.opcao === 'SIM').length;
    const nao = votosAtuais.filter(v => v.opcao === 'NAO').length;
    const abs = votosAtuais.filter(v => v.opcao === 'ABSTENCAO').length;
    const totalVotos = sim + nao + abs;
    const resultado = sim > nao ? 'APROVADA' : 'REPROVADA';
    const votaramTodos = totalPresentes > 0 && totalVotos >= totalPresentes;
    const msg = votaramTodos
      ? `Encerrar votação? Resultado: ${resultado} (SIM: ${sim}, NÃO: ${nao}, ABST: ${abs})`
      : `⚠️ ATENÇÃO: Apenas ${totalVotos} de ${totalPresentes} vereador(es) presente(s) votaram.\n\nDeseja encerrar mesmo assim? Resultado parcial: ${resultado} (SIM: ${sim}, NÃO: ${nao}, ABST: ${abs})`;
    if (!window.confirm(msg)) return;
    try {
      await axios.patch(`/api/pautas/${pauta.id}/encerrar`, { resultado });
      toast.success(`Pauta ${resultado === 'APROVADA' ? '✅ Aprovada' : '❌ Reprovada'}!`);
    } catch { toast.error('Erro ao encerrar votação'); }
  };

  const mudarStatusSessao = async (status) => {
    const msg = status === 'EM_ANDAMENTO' ? 'Iniciar sessão?' : status === 'ENCERRADA' ? 'Encerrar sessão?' : 'Reabrir sessão?';
    if (!window.confirm(msg)) return;
    try {
      await axios.patch(`/api/sessoes/${sessao?.id}/status`, { status });
      toast.success(status === 'EM_ANDAMENTO' ? 'Sessão iniciada!' : status === 'ENCERRADA' ? 'Sessão encerrada!' : 'Sessão reaberta!');
      buscarSessao();
    } catch (err) { toast.error(err.response?.data?.error || 'Erro ao atualizar sessão'); }
  };

  const iniciarCronometro = () => {
    const segundos = tempoOrador * 60;
    const vSel = vereadores.find(v => v.id === vereadorSelecionado) || vereadores.find(v => v.nome === nomeOrador);
    const fotoSel = vSel?.fotoUrl || '';
    setFotoOrador(fotoSel);
    setTempoRestante(segundos); setCronometroAtivo(true); setCronometroPausado(false); setModalCronometro(false);
    socketRef.current?.emit('cronometro-update', { sessaoId: sessao?.id, tempo: segundos, tempoTotal: segundos, nome: nomeOrador, foto: fotoSel, encerrado: false, iniciado: true });
    toast.success(`Cronômetro iniciado para ${nomeOrador || 'Orador'}!`);
  };

  const pararCronometro = () => {
    clearInterval(intervalRef.current);
    const tempoDecorrido = tempoOrador * 60 - tempoRestante;
    setCronometroAtivo(false); setCronometroPausado(false); setTempoRestante(0); setFotoOrador('');
    socketRef.current?.emit('cronometro-update', { sessaoId: sessao?.id, tempo: 0, nome: '', encerrado: true });
    toast('Cronômetro encerrado');
    // Registrar uso da palavra ao parar manualmente (se houve pelo menos 5s de fala)
    if (sessao?.id && nomeOrador && tempoDecorrido >= 5) {
      const vId = vereadores.find(v => v.nome === nomeOrador)?.id || null;
      const part = vereadores.find(v => v.nome === nomeOrador)?.partido || null;
      axios.post('/api/uso-palavra', {
        sessaoId: sessao.id,
        vereadorId: vId,
        nome: nomeOrador,
        partido: part,
        tempoTotal: tempoDecorrido
      }).catch(() => {});
    }
  };

  const pausarCronometro = () => {
    const pausando = !cronometroPausado;
    setCronometroPausado(pausando);
    clearInterval(intervalRef.current);
    socketRef.current?.emit('cronometro-update', {
      sessaoId: sessao?.id,
      tempo: tempoRestante,
      nome: nomeOrador,
      foto: fotoOrador,
      encerrado: false,
      pausado: pausando,
    });
  };

  // PLENARIUM:VOTACAO_BLOCO -- outras materias do bloco em votacao (se houver)
  const membrosBloco = pautaAtiva ? (pautaAtiva.bloco || pautas.filter(x => x.blocoId && x.blocoId === pautaAtiva.id && x.id !== pautaAtiva.id && x.status === 'PENDENTE')) : [];
  const pautasAviso = pautas.map(p => {
    if (!(p.blocoId && p.blocoId === p.id)) return p;
    const doBloco = pautas.filter(x => x.blocoId === p.id);
    return doBloco.length > 1 ? { ...p, numero: `Votação em bloco · ${doBloco.length} matérias`, titulo: doBloco.map(x => x.numero).join(' · ') } : p;
  });

  const formatarTempo = (seg) => {
    const m = Math.floor(seg / 60).toString().padStart(2, '0');
    const s = (seg % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  const corCronometro = tempoRestante > 60 ? '#16a34a' : tempoRestante > 30 ? '#d97706' : '#dc2626';

  const enviarRequerimento = async (e) => {
    e.preventDefault(); setSalvandoReq(true);
    try { await axios.post('/api/projetos/vereador/novo', formReq); toast.success('Requerimento enviado!'); setFormReq(VAZIO_REQ); buscarMeusProjetos(); setAba('projetos'); }
    catch (err) { toast.error(err.response?.data?.error || 'Erro ao enviar'); }
    finally { setSalvandoReq(false); }
  };

  const alterarSenha = async (e) => {
    e.preventDefault();
    if (novaSenha !== confirmarSenha) { toast.error('As senhas não coincidem!'); return; }
    if (novaSenha.length < 6) { toast.error('Mínimo 6 caracteres!'); return; }
    setSalvandoSenha(true);
    try { await axios.patch('/api/vereadores/alterar-senha', { senhaAtual, novaSenha }); toast.success('Senha alterada!'); setModalSenha(false); setSenhaAtual(''); setNovaSenha(''); setConfirmarSenha(''); }
    catch (err) { toast.error(err.response?.data?.error || 'Erro ao alterar senha'); }
    finally { setSalvandoSenha(false); }
  };

  const alterarFoto = async (e) => {
    e.preventDefault();
    if (!novaFoto) { toast.error('Selecione uma foto!'); return; } setSalvandoFoto(true);
    try {
      const res = await axios.patch('/api/vereadores/alterar-foto', { fotoUrl: novaFoto });
      setFotoAtual(res.data.fotoUrl);
      localStorage.setItem('usuario', JSON.stringify({ ...usuario, fotoUrl: res.data.fotoUrl }));
      toast.success('Foto atualizada!'); setModalFoto(false); setNovaFoto('');
    } catch (err) { toast.error(err.response?.data?.error || 'Erro ao atualizar foto'); }
    finally { setSalvandoFoto(false); }
  };

  const handleReordenar = async (index, direcao) => {
    const novaLista = [...pautas];
    const alvo = direcao === 'cima' ? index - 1 : index + 1;
    if (alvo < 0 || alvo >= novaLista.length) return;
    [novaLista[index], novaLista[alvo]] = [novaLista[alvo], novaLista[index]];
    const listaOrdenada = novaLista.map((p, i) => ({ ...p, ordem: i }));
    setPautas(listaOrdenada);
    try {
      await axios.patch('/api/pautas/reordenar', { pautas: listaOrdenada.map(p => ({ id: p.id, ordem: p.ordem })) });
    } catch { toast.error('Erro ao reordenar'); buscarSessao(); }
  };

  const handleRetirar = async (pauta) => {
    if (!window.confirm(`Retirar "${pauta.titulo}" da ordem do dia?`)) return;
    try {
      await axios.patch(`/api/pautas/${pauta.id}/retirar`);
      setPautas(prev => prev.map(p => p.id === pauta.id ? { ...p, status: 'RETIRADA' } : p));
      toast.success('Pauta retirada da ordem do dia.');
    } catch { toast.error('Erro ao retirar pauta'); }
  };

  const handleLogout = () => {
    const slug = usuario?.camara?.slug;
    logout();
    if (slug) navigate(`/camara/${slug}/login/vereador`);
    else navigate('/login/vereador');
  };
  const projetosFiltrados = meusProjetos.filter(p => filtroProjeto === 'TODOS' || p.status === filtroProjeto);
  const iniciais = usuario?.nome?.split(' ').map(n => n[0]).slice(0, 2).join('') || '?';
  const fotoExibida = fotoAtual || usuario?.fotoUrl || '';
  const pautasPendentes = pautas.filter(p => p.status === 'PENDENTE');
  const totalPresentes = presencas.length > 0
    ? presencas.filter(p => p.presente).length
    : vereadores.length;
  const tipoQuorum = sessao?.tipoQuorum || 'MAIORIA_ABSOLUTA';
  // O presidente conta como presente, mas não entra na base de cálculo do
  // quórum (ele só vota em caso de empate — voto de minerva).
  const presidenteVereador = vereadores.find(v => v.cargo === 'PRESIDENTE');
  const presidentePresente = presidenteVereador
    ? (presencas.length > 0 ? !!presencas.find(p => p.id === presidenteVereador.id)?.presente : true)
    : false;
  const totalVereadoresVotantes = vereadores.filter(v => v.cargo !== 'PRESIDENTE').length;
  const totalPresentesVotantes = totalPresentes - (presidentePresente ? 1 : 0);
  // PLENARIUM:QUORUM_CAMARA -- numero fixo da camara: abertura ate a Ordem do Dia, depois o de votacao
  const quorumMinimo = quorumDaCamara(estruturaPV, sessao && (sessao.ordemDoDiaIniciada || chamada2PV) ? 'votacao' : 'abertura', tipoQuorum === 'MAIORIA_SIMPLES'
    ? Math.floor(totalPresentesVotantes / 2) + 1
    : Math.floor(totalVereadoresVotantes / 2) + 1);

  // Usa contagemRT (tempo real via socket) se houver votos, senão usa os votos da pauta
  // PLENARIUM:SEGURANCA -- secreta aberta: so o total; SIM/NAO/ABST so ao encerrar
  const secretaAberta = !!(pautaAtiva && pautaAtiva.votacaoSecreta && pautaAtiva.status === 'EM_VOTACAO');
  const contagem = pautaAtiva ? (
    secretaAberta ? { SIM: '--', NAO: '--', ABSTENCAO: '--', TOTAL: Math.max(contagemRT.TOTAL || 0, pautaAtiva.totalVotos || 0) } :
    contagemRT.TOTAL > 0 ? contagemRT : {
      SIM: pautaAtiva.votos?.filter(v => v.opcao === 'SIM').length || 0,
      NAO: pautaAtiva.votos?.filter(v => v.opcao === 'NAO').length || 0,
      ABSTENCAO: pautaAtiva.votos?.filter(v => v.opcao === 'ABSTENCAO').length || 0,
      TOTAL: pautaAtiva.votos?.length || 0,
    }
  ) : { SIM: 0, NAO: 0, ABSTENCAO: 0, TOTAL: 0 };

  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;

  // CSS injetado para bottom bar mobile (complementa o CSS externo pv-*)
  const mobileCSS = `
    @media (max-width: 1280px) {
      .pv-bottom-bar { display: flex !important; }
      .pv-sidebar { display: none !important; }
      .pv-main { padding-bottom: calc(68px + env(safe-area-inset-bottom)) !important; background: #f1f5f9 !important; }
      .pv-header-desktop { display: none !important; }
      .pv-header-mobile { display: flex !important; }
      .pv-lateral { display: none !important; }
      .pv-resultado-mobile { display: block !important; }
      .pv-ordem { display: none !important; }
      .pv-como-votar-label { display: block !important; }
      .pv-votacao { flex-direction: column !important; }
      .pv-votacao-centro { width: 100% !important; }
      .pv-pauta-card { background: white !important; border: 0.5px solid #e2e8f0 !important; }
      .pv-stats { background: white !important; border: 0.5px solid #e2e8f0 !important; border-radius: 12px !important; }
      .modal-overlay {
        z-index: 2000 !important;
        align-items: center !important;
        justify-content: center !important;
        padding: 16px 16px calc(68px + env(safe-area-inset-bottom) + 16px) !important;
        box-sizing: border-box !important;
      }
      .modal-overlay > .modal {
        max-height: calc(100dvh - 68px - env(safe-area-inset-bottom) - 48px) !important;
        overflow-y: auto !important;
        border-radius: 16px !important;
        width: 100% !important;
      }
    }
  `;

  // ══════════════════════════════════════════
  // LAYOUT PRESIDENTE — sidebar igual ao vereador
  // ══════════════════════════════════════════
  if (isPresidente) return (
    <>
    <style>{mobileCSS}</style>
    <AutorizarMudancaVoto sessaoId={sessao?.status === 'EM_ANDAMENTO' ? sessao.id : null} modo="tablet" meuId={usuario?.id} /> {/* PLENARIUM:MUDANCA_VOTO */}
    <EleicaoMesaVereador sessaoId={sessao?.id} />
    <style>{CSS_CARDS}</style>
    <TelaPresenca sessaoId={sessao?.status === 'EM_ANDAMENTO' ? sessao.id : null} usuario={usuario} fotoExibida={fotoExibida} onLogout={handleLogout} />
    <AvisoResultado pautas={pautasAviso} /> {/* PLENARIUM:VOTACAO_BLOCO */}
    <CronometroTablet cron={cronometroSocket} vereadores={vereadores} usuario={usuario} votacaoAberta={!!pautaAtiva} /> {/* PLENARIUM:CRONOMETRO_TABLET */}
    <GavetaOrdem aberto={verOrdem} onFechar={() => setVerOrdem(false)} pautas={pautas} />
    <VoltarDoCelular aba={aba} setAba={setAba} verOrdem={verOrdem} setVerOrdem={setVerOrdem} /> {/* PLENARIUM:CARDS v5 */}
    <div className="pv-root pv-cards">

      {/* Barra cronômetro ativo */}
      {cronometroAtivo && (
        <div style={{ background: corCronometro, padding: '7px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8, flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Timer size={14} color="white" />
            <span style={{ color: 'white', fontWeight: 700, fontSize: '0.936rem' }}>{nomeOrador || 'Orador em fala'}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
            <span style={{ fontFamily: 'monospace', fontSize: '1.44rem', fontWeight: 800, color: 'white' }}>{formatarTempo(tempoRestante)}</span>
            {[30, 60, 180].map(seg => (
              <button key={seg} onClick={() => adicionarTempo(seg)} style={{ background: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.4)', color: 'white', padding: '3px 7px', borderRadius: 6, cursor: 'pointer', fontSize: '0.84rem', fontWeight: 700 }}>
                {seg < 60 ? `+${seg}s` : `+${seg/60}min`}
              </button>
            ))}
            <input type="number" min={1} placeholder="s" style={{ width: 40, padding: '2px 4px', borderRadius: 6, border: '1px solid rgba(255,255,255,0.4)', background: 'rgba(255,255,255,0.15)', color: 'white', fontSize: '0.84rem', textAlign: 'center' }}
              onKeyDown={e => { if (e.key === 'Enter' && Number(e.target.value) > 0) { adicionarTempo(Number(e.target.value)); e.target.value = ''; } }} />
            <button onClick={pausarCronometro} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: 'white', padding: '3px 8px', borderRadius: 6, cursor: 'pointer', fontSize: '0.864rem', fontWeight: 700 }}>
              {cronometroPausado ? '▶️ Retomar' : '⏸️ Pausar'}
            </button>
            <button onClick={pararCronometro} style={{ background: 'rgba(0,0,0,0.2)', border: 'none', color: 'white', padding: '3px 8px', borderRadius: 6, cursor: 'pointer', fontSize: '0.864rem', fontWeight: 700 }}>⏹️ Parar</button>
          </div>
        </div>
      )}

      {/* ════ CABEÇALHO CÂMARA ════ */}
      <div className="pv-cabecalho-camara" style={{ background: 'linear-gradient(90deg, #0f172a 0%, #1a2d5a 100%)', flexShrink: 0, borderBottom: '2px solid #fbbf24' }}>

        {/* Header Desktop */}
        <div className="pv-header-desktop" style={{ padding: '10px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ width: 64, height: 64, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              {usuario?.camara?.logoUrl
                ? <img src={usuario.camara.logoUrl} alt="Logo" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                : <span style={{ fontSize: '1.32rem' }}>🏛️</span>
              }
            </div>
            <p style={{ color: 'white', fontSize: '1.32rem', fontWeight: 800, margin: 0 }}>
              {usuario?.camara?.nome || 'Câmara Municipal'}
            </p>
          </div>
          {/* Logo Plenarium Digital */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
            <img src="/logo512.png" alt="Plenarium Digital" style={{ height: 32, objectFit: 'contain', mixBlendMode: 'screen' }} />
            <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.864rem', fontWeight: 700, letterSpacing: '0.5px' }}>PLENARIUM DIGITAL</span>
          </div>
        </div>

        {/* Header Mobile */}
        <div className="pv-header-mobile" style={{ display: 'none', flexDirection: 'column', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
          {/* Linha 1: Logo câmara centralizada */}
          <div style={{ padding: '8px 14px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
            <div className="pv-brasao" style={{ width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {usuario?.camara?.logoUrl
                ? <img src={usuario.camara.logoUrl} alt="Logo" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                : <span style={{ fontSize: '1.2rem' }}>🏛️</span>
              }
            </div>
            <span style={{ color: 'white', fontSize: '0.9rem', fontWeight: 700 }}>{usuario?.camara?.nome || 'Câmara Municipal'}</span>
          </div>
          {/* Linha 2: Foto+nome do vereador (esq) | Logo Plenarium (dir) */}
          <div style={{ padding: '8px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>

              <div>
                <p style={{ color: 'white', fontSize: '0.864rem', fontWeight: 700, margin: '0 0 1px' }}>{exibCurto(usuario)}</p>
                <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.744rem', margin: 0 }}>{usuario?.partido}</p>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
              <img src="/logo512.png" alt="Plenarium Digital" style={{ height: 24, objectFit: 'contain', mixBlendMode: 'screen' }} />
              <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.696rem', fontWeight: 700, letterSpacing: '0.4px', lineHeight: 1.3 }}>PLENARIUM<br/>DIGITAL</span>
            </div>
          </div>
        </div>

        <div style={{ padding: '6px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ width: 6, height: 6, borderRadius: '50%', background: sessao ? '#22c55e' : '#64748b', flexShrink: 0, animation: sessao ? 'pulse 1.4s ease infinite' : 'none' }} />
            <span style={{ color: 'rgba(255,255,255,0.65)', fontSize: '0.816rem', fontWeight: 600, letterSpacing: '0.3px' }}>
              {sessao ? `SESSÃO EM ANDAMENTO — ${sessao.titulo}` : 'AGUARDANDO SESSÃO'}
            </span>
          </div>
          {/* Botões de sessão no cabeçalho */}
          <div style={{ display: 'flex', gap: 6 }}>
            {sessao?.status === 'AGENDADA' && (
              <button onClick={() => mudarStatusSessao('EM_ANDAMENTO')} style={{ background: '#16a34a', border: 'none', color: 'white', fontSize: '0.78rem', fontWeight: 700, padding: '3px 10px', borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}>
                <Play size={10} /> Iniciar Sessão
              </button>
            )}
            {sessao?.status === 'EM_ANDAMENTO' && (
              <button onClick={() => mudarStatusSessao('ENCERRADA')} style={{ background: '#dc2626', border: 'none', color: 'white', fontSize: '0.78rem', fontWeight: 700, padding: '3px 10px', borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}>
                <Square size={10} /> Encerrar Sessão
              </button>
            )}
            {sessao?.status === 'ENCERRADA' && (
              <button onClick={() => mudarStatusSessao('EM_ANDAMENTO')} style={{ background: '#d97706', border: 'none', color: 'white', fontSize: '0.78rem', fontWeight: 700, padding: '3px 10px', borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}>
                <Play size={10} /> Reabrir Sessão
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="pv-body">

        {/* ════ SIDEBAR PRESIDENTE ════ */}
        <aside className="pv-sidebar">


          {/* Nav */}
          <nav className="pv-nav">
            <button className={`pv-nav-item ${aba === 'votacao' ? 'ativo' : ''}`} onClick={() => setAba('votacao')}>
              <Vote size={15} /> Votação
              {pautaAtiva && <span className="pv-nav-badge" />}
            </button>
            <button className={`pv-nav-item ${aba === 'ordem' ? 'ativo' : ''}`} onClick={() => setAba('ordem')}>
              <Calendar size={15} /> Ordem do Dia
            </button>
            <button className={`pv-nav-item ${aba === 'historico' ? 'ativo' : ''}`} onClick={() => setAba('historico')}>
              <History size={15} /> Sessões
            </button>
            <button className={`pv-nav-item ${aba === 'projetos' ? 'ativo' : ''}`} onClick={() => setAba('projetos')}>
              <FileText size={15} /> Meus Projetos
            </button>
            <button className={`pv-nav-item ${aba === 'requerimento' ? 'ativo' : ''}`} onClick={() => setAba('requerimento')}>
              <Plus size={15} /> Requerimento
            </button>
            {/* PLENARIUM:RECARREGAR */}
            <button className="pv-nav-item" onClick={() => window.location.reload()}>
              <RefreshCw size={15} /> Recarregar tela
            </button>
            <button className="pv-nav-item" onClick={() => setModalSenha(true)}>
              <KeyRound size={15} /> Alterar Senha
            </button>

            {/* Divisor — exclusivos do presidente */}
            <div style={{ height: 1, background: 'rgba(255,255,255,0.07)', margin: '4px 12px' }} />

            <button className={`pv-nav-item ${aba === 'controle' ? 'ativo' : ''}`} onClick={() => setAba('controle')}
              style={{ color: aba === 'controle' ? 'white' : 'rgba(252,165,165,0.85)', borderLeftColor: aba === 'controle' ? '#dc2626' : 'transparent', background: aba === 'controle' ? 'rgba(220,38,38,0.15)' : 'none' }}>
              <Play size={15} color={aba === 'controle' ? 'white' : '#fca5a5'} /> Ctrl. Votação
              {sessao && pautasPendentes.length > 0 && <span className="pv-nav-badge" />}
            </button>
            <button className={`pv-nav-item ${aba === 'presenca' ? 'ativo' : ''}`} onClick={() => setAba('presenca')}
              style={{ color: aba === 'presenca' ? 'white' : 'rgba(94,234,212,0.85)', borderLeftColor: aba === 'presenca' ? '#0891b2' : 'transparent', background: aba === 'presenca' ? 'rgba(8,145,178,0.15)' : 'none' }}>
              <Users size={15} color={aba === 'presenca' ? 'white' : '#5eead4'} /> Presença
            </button>
            {/* aba Cronômetro removida do acesso do presidente — operado somente pelo admin */}
          </nav>

          <div className="pv-sair">
            <button onClick={() => setModoClaro(m => !m)} style={{ marginBottom: 6, background: modoClaro ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.15)', color: modoClaro ? '#fbbf24' : 'rgba(255,255,255,0.6)', borderRadius: 8, padding: '7px', width: '100%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, fontSize: '0.9rem', fontWeight: 600, fontFamily: 'Inter, sans-serif' }}>
              {modoClaro ? <Moon size={13} /> : <Sun size={13} />} {modoClaro ? 'Modo Escuro' : 'Modo Claro'}
            </button>
            <button onClick={handleLogout}><LogOut size={14} /> Sair</button>
          </div>
        </aside>

        {/* ════ ÁREA PRINCIPAL ════ */}
        <main className="pv-main">

          {/* Conteúdo das abas */}
          {aba === 'votacao' && (
            <>
              <BarraSecao comissoes={infoComissoes} leituras={mostraLeituras} aba={aba} setAba={setAba} isPresidente={isPresidente} sessao={sessao} usuario={usuario} fotoExibida={fotoExibida} onOrdem={() => setVerOrdem(true)} pautaAtiva={pautaAtiva} /> {/* PLENARIUM:CARDS */}
              {!sessao ? (
                <TelaSemSessaoCards historico={historico} usuario={usuario} fotoExibida={fotoExibida} /> /* PLENARIUM:CARDS v4 */
              ) : !pautaAtiva ? (
                <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px', background: '#f8fafc', display: 'flex', flexDirection: 'column', gap: 16 }}>

                  {/* Foto do vereador */}
                  <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: 12, padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 16 }}>
                    <div style={{ width: 72, height: 72, borderRadius: 10, overflow: 'hidden', border: '2px solid #e2e8f0', flexShrink: 0, background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {fotoExibida
                        ? <img src={fotoExibida} alt={usuario?.nome} style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top' }} />
                        : <span style={{ fontSize: 24, fontWeight: 700, color: '#94a3b8' }}>{usuario?.nome?.split(' ').map(n => n[0]).slice(0,2).join('') || '?'}</span>
                      }
                    </div>
                    <div>
                      <div style={{ fontSize: 11, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 3 }}>Bem-vindo(a)</div>
                      <div style={{ fontSize: 18, fontWeight: 800, color: '#0f172a' }}>{exib(usuario) || 'Vereador'}</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
                        <span style={{ fontSize: 11, background: '#eff6ff', color: '#1d4ed8', padding: '2px 10px', borderRadius: 20, fontWeight: 600 }}>{tratamento(usuario)}</span>
                        {usuario?.partido && <span style={{ fontSize: 11, color: '#94a3b8' }}>{usuario.partido}</span>}
                      </div>
                    </div>
                  </div>

                  {/* Header da sessão */}
                  <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: 12, padding: '16px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                      <div style={{ width: 44, height: 44, borderRadius: 10, background: '#eff6ff', border: '1.5px solid #bfdbfe', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <Calendar size={22} color="#3b82f6" />
                      </div>
                      <div>
                        <div style={{ fontWeight: 800, color: '#0f172a', fontSize: '1.2rem' }}>{sessao.titulo}</div>
                        <div style={{ fontSize: '0.936rem', color: '#64748b', marginTop: 2 }}>
                          {new Date(sessao.data).toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' })} • {new Date().toLocaleTimeString('pt-BR')}
                        </div>
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 12 }}>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '0.84rem', fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'flex', alignItems: 'center', gap: 4 }}><Users size={11} color="#64748b" /> Presenças</div>
                        <div style={{ fontSize: '1.32rem', fontWeight: 800, color: '#1d4ed8' }}>{totalPresentes} / {vereadores.length}</div>
                        <div style={{ fontSize: '0.78rem', color: '#94a3b8' }}>Vereadores presentes</div>
                      </div>
                      <div style={{ width: 1, background: '#e2e8f0' }} />
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '0.84rem', fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'flex', alignItems: 'center', gap: 4 }}><CheckCircle size={11} color="#64748b" /> Quórum</div>
                        <div style={{ fontSize: '1.32rem', fontWeight: 800, color: totalPresentes >= quorumMinimo ? '#16a34a' : '#dc2626' }}>{totalPresentes >= quorumMinimo ? 'OK' : 'NOK'}</div>
                        <div style={{ fontSize: '0.78rem', color: '#94a3b8' }}>{totalPresentes >= quorumMinimo ? 'Quórum atingido' : 'Quórum insuficiente'}</div>
                      </div>
                      <div style={{ width: 1, background: '#e2e8f0' }} />
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                          <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#dc2626', animation: 'pulse 1.4s ease infinite' }} />
                          <div style={{ fontSize: '0.84rem', fontWeight: 700, color: '#dc2626', textTransform: 'uppercase' }}>AO VIVO</div>
                        </div>
                        <div style={{ fontSize: '0.78rem', color: '#94a3b8', marginTop: 2 }}>Transmissão plenária</div>
                      </div>
                    </div>
                  </div>

                  <CartaoPresenca sessaoId={sessao?.id} />
                  {/* Aguardando votação */}
                  <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 12, padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#3b82f6', animation: 'pulse 1.4s ease infinite', flexShrink: 0 }} />
                    <span style={{ fontSize: '1.02rem', color: '#1d4ed8', fontWeight: 600 }}>Aguardando abertura de votação pelo presidente da sessão</span>
                  </div>
                  <VotosDosVereadores pautaAtiva={null} jaVotou={false} sessaoId={sessao?.id} pautas={pautas} /> {/* PLENARIUM:VOTOS_AO_VIVO -- resultado da ultima, ate abrir a proxima */}
                  <MudarMeuVoto sessao={sessao} /> {/* PLENARIUM:MUDANCA_VOTO */}

                  {/* Atividade na sessão atual + Parlamentar — OCULTOS a pedido em 19/08/2026.
                      Estavam poluindo a tela inicial da sessão. O código foi mantido inteiro
                      (só a exibição está desligada pela condição false abaixo), porque o
                      cálculo servirá de base ao futuro gerador de relatórios.
                      Para voltar a exibir, troque false por true. */}
                  {false && (
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>

                    {/* Atividade na sessão atual */}
                    <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: 12, padding: '18px 20px' }}>
                      <div style={{ fontSize: '0.9rem', fontWeight: 800, color: '#0f172a', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 4 }}>ATIVIDADE NA SESSÃO ATUAL</div>
                      <div style={{ width: 32, height: 3, background: '#eab308', borderRadius: 99, marginBottom: 16 }} />
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
                        {[
                          { icon: <Vote size={18} color={"currentColor"} />, value: sessao.pautas?.filter(p => p.status !== 'PENDENTE').length || 0, label: 'Votações', sub: 'Participou', color: '#4338ca', bg: '#ede9fe' },
                          { icon: <CheckCircle size={18} color={"currentColor"} />, value: `${totalPresentes >= vereadores.length ? '100' : Math.round((totalPresentes/Math.max(vereadores.length,1))*100)}%`, label: 'Presenças', sub: 'Na sessão', color: '#16a34a', bg: '#dcfce7' },
                          { icon: <Mic size={18} color={"currentColor"} />, value: meusDiscursos.filter(d => d.sessaoId === sessao?.id).length, label: 'Discursos', sub: 'Realizados', color: '#7c3aed', bg: '#ede9fe' },
                          { icon: <FileText size={18} color={"currentColor"} />, value: meusProjetos.filter(p => p.tipo === 'Requerimento').length, label: 'Requerimentos', sub: 'Apresentados', color: '#d97706', bg: '#fef9c3' },
                        ].map((c, i) => (
                          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#f8fafc', borderRadius: 10, padding: '10px 12px', border: '1px solid #f1f5f9' }}>
                            <div style={{ width: 36, height: 36, borderRadius: 8, background: c.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{c.icon}</div>
                            <div>
                              <div style={{ fontSize: '1.32rem', fontWeight: 800, color: c.color, lineHeight: 1 }}>{c.value}</div>
                              <div style={{ fontSize: '0.864rem', fontWeight: 600, color: '#334155' }}>{c.label}</div>
                              <div style={{ fontSize: '0.78rem', color: '#94a3b8' }}>{c.sub}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div style={{ background: '#eff6ff', borderRadius: 8, padding: '10px 14px', fontSize: '0.936rem', color: '#1d4ed8', fontWeight: 500, display: 'flex', alignItems: 'center', gap: 6 }}>
                        Você está conectado e participando desta sessão.
                      </div>
                    </div>

                    {/* Atividade parlamentar */}
                    <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: 12, padding: '18px 20px' }}>
                      <div style={{ fontSize: '0.9rem', fontWeight: 800, color: '#0f172a', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 4 }}>ATIVIDADE PARLAMENTAR</div>
                      <div style={{ width: 32, height: 3, background: '#eab308', borderRadius: 99, marginBottom: 16 }} />
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
                        {[
                          { icon: <Vote size={18} color={"currentColor"} />, value: historico.reduce((a, s) => a + (s.pautas?.length || 0), 0), label: 'Votações', sub: 'Participou', color: '#4338ca', bg: '#ede9fe' },
                          { icon: <Mic size={18} color={"currentColor"} />, value: meusDiscursos.length, label: 'Discursos', sub: 'Realizados', color: '#7c3aed', bg: '#ede9fe' },
                          { icon: <FileText size={18} color={"currentColor"} />, value: meusProjetos.filter(p => p.tipo === 'Requerimento').length, label: 'Requerimentos', sub: 'Apresentados', color: '#d97706', bg: '#fef9c3' },
                          { icon: <ClipboardList size={18} color={"currentColor"} />, value: meusProjetos.length, label: 'Projetos', sub: 'Apoiados', color: '#16a34a', bg: '#dcfce7' },
                        ].map((c, i) => (
                          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#f8fafc', borderRadius: 10, padding: '10px 12px', border: '1px solid #f1f5f9' }}>
                            <div style={{ width: 36, height: 36, borderRadius: 8, background: c.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{c.icon}</div>
                            <div>
                              <div style={{ fontSize: '1.32rem', fontWeight: 800, color: c.color, lineHeight: 1 }}>{c.value}</div>
                              <div style={{ fontSize: '0.864rem', fontWeight: 600, color: '#334155' }}>{c.label}</div>
                              <div style={{ fontSize: '0.78rem', color: '#94a3b8' }}>{c.sub}</div>
                            </div>
                          </div>
                        ))}
                      </div>

                    </div>
                  </div>
                  )}
                </div>
              ) : (
                <div className="pv-votacao">
                  <div className="pv-votacao-centro">
                    <div className="pv-pauta-card">
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
                        <span className="pv-pauta-tag">{membrosBloco.length ? 'VOTAÇÃO EM BLOCO' : 'PROJETO EM VOTAÇÃO'}</span>
                        <span className="pv-pauta-numero">{membrosBloco.length ? `${membrosBloco.length + 1} matérias` : pautaAtiva.numero}</span>
                      </div>
                      <div className="pv-pauta-body">
                        <div style={{ flex: 1, minWidth: 140 }}>
                          {membrosBloco.length ? <ListaBloco itens={[pautaAtiva, ...membrosBloco]} /> : (<>
                            <h3 className="pv-pauta-titulo">{pautaAtiva.titulo}</h3>
                            <p className="pv-pauta-subtipo">{TIPO_LABEL[pautaAtiva.tipo]}</p>
                            {pautaAtiva.projetoId && <PareceresResumo projetoId={pautaAtiva.projetoId} />} {/* PLENARIUM:COMISSOES */}
                            {pautaAtiva.tipo === 'ATA_ANTERIOR' && pautaAtiva.retificacao && <div style={{ marginTop: 8, background: '#fef3c7', color: '#78350f', borderRadius: 10, padding: '8px 12px', whiteSpace: 'pre-wrap', fontSize: '.92rem', lineHeight: 1.45 }}><b>Com retificação:</b>{'\n'}{pautaAtiva.retificacao}</div>} {/* PLENARIUM:ATA_RETIFICACAO */}
                          </>)}
                        </div>
                      </div>
                    </div>
                    {!jaVotou ? (
                      <>
                        <p className="pv-como-votar-label" style={{ display: 'none', textAlign: 'center', color: '#475569', fontSize: '1.02rem', fontWeight: 500, margin: '4px 0 8px' }}>Como deseja votar?</p>
                        {meuVoto && <p style={{ textAlign: 'center', color: '#0f172a', fontSize: '1rem', fontWeight: 600, margin: '4px 0 10px' }}>Seu voto atual: <b>{meuVoto === 'SIM' ? 'SIM' : meuVoto === 'NAO' ? 'NÃO' : 'ABSTENÇÃO'}</b>. Toque no novo voto ou <button type="button" onClick={() => setJaVotou(true)} style={{ border: 0, background: 'none', color: '#2563eb', fontWeight: 800, fontSize: '1rem', cursor: 'pointer', textDecoration: 'underline', padding: 0, fontFamily: 'inherit' }}>manter</button>.</p>}{/* PLENARIUM:TROCA_VOTO */}
                        <div className="pv-botoes-voto">
                          <button className="pv-btn-voto pv-btn-sim" onClick={() => votar('SIM')} disabled={votando}><CheckCircle size={22} /> SIM</button>
                          <button className="pv-btn-voto pv-btn-nao" onClick={() => votar('NAO')} disabled={votando}><XCircle size={22} /> NÃO</button>
                          <button className="pv-btn-voto pv-btn-abst" onClick={() => votar('ABSTENCAO')} disabled={votando}><MinusCircle size={22} /> ABSTENÇÃO</button>
                        </div>
                      </>
                    ) : (
                      <div className="pv-voto-ok" style={{ background: meuVoto === 'SIM' ? '#dcfce7' : meuVoto === 'NAO' ? '#fee2e2' : '#f1f5f9', borderColor: meuVoto === 'SIM' ? '#16a34a' : meuVoto === 'NAO' ? '#dc2626' : '#cbd5e1' }}>
                        <span style={{ fontSize: '2.16rem' }}>{meuVoto === 'SIM' ? '✅' : meuVoto === 'NAO' ? '❌' : '⚪'}</span>
                        <div>
                          <p style={{ fontWeight: 800, fontSize: '1.056rem', color: '#0f172a', margin: '0 0 2px' }}>SEU VOTO FOI REGISTRADO!</p>
                          <p style={{ color: '#64748b', fontSize: '0.9rem', margin: 0 }}>Aguardando resultado final da votação.</p>
                          <button type="button" className="pv-alterar-voto" onClick={() => setJaVotou(false)} style={{ marginTop: 8, padding: '8px 14px', borderRadius: 10, border: '1px solid #94a3b8', background: '#fff', color: '#0f172a', fontWeight: 700, fontSize: '.9rem', cursor: 'pointer', fontFamily: 'inherit' }}>Votei errado: alterar meu voto</button>{/* PLENARIUM:TROCA_VOTO */}
                        </div>
                      </div>
                    )}
                    {/* Resultado parcial — só mobile */}
                    <div className="pv-resultado-mobile" style={{ display: 'none', background: 'white', borderRadius: 12, padding: 12, border: '0.5px solid #e2e8f0', marginTop: 4 }}>
                      <p style={{ color: '#64748b', fontSize: '0.84rem', fontWeight: 700, letterSpacing: '0.5px', margin: '0 0 8px', textTransform: 'uppercase' }}>Resultado Parcial</p>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 6 }}>
                        {[
                          { label: 'SIM',   valor: contagem.SIM,       cor: '#15803d', bg: '#f0fdf4', border: '#bbf7d0' },
                          { label: 'NÃO',   valor: contagem.NAO,       cor: '#b91c1c', bg: '#fef2f2', border: '#fecaca' },
                          { label: 'ABST.', valor: contagem.ABSTENCAO, cor: '#b45309', bg: '#fffbeb', border: '#fde68a' },
                          { label: 'TOTAL', valor: contagem.TOTAL,     cor: '#0f172a', bg: '#f8fafc', border: '#e2e8f0' },
                        ].map((item, i) => (
                          <div key={i} style={{ background: item.bg, borderRadius: 8, padding: '8px 4px', textAlign: 'center', border: `0.5px solid ${item.border}` }}>
                            <p style={{ color: item.cor, fontSize: '0.78rem', fontWeight: 700, margin: '0 0 3px' }}>{item.label}</p>
                            <p style={{ color: item.cor, fontSize: '1.44rem', fontWeight: 800, margin: 0 }}>{String(item.valor || 0).padStart(2, '0')}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                    <VotosDosVereadores pautaAtiva={pautaAtiva} jaVotou={jaVotou} sessaoId={sessao?.id} pautas={pautas} meuId={usuario?.id} meuVoto={meuVoto} /> {/* PLENARIUM:VOTOS_AO_VIVO -- abaixo do resultado parcial */}
                  </div>
                  <div className="pv-lateral">
                    <div>
                      <div className="pv-lateral-titulo"><div className="pv-lateral-linha" /><span className="pv-lateral-label">Resultado Parcial</span></div>
                      {[
                        { label: 'SIM',   valor: contagem.SIM,       cor: '#16a34a', bg: '#dcfce7' },
                        { label: 'NÃO',   valor: contagem.NAO,       cor: '#dc2626', bg: '#fee2e2' },
                        { label: 'ABST.', valor: contagem.ABSTENCAO, cor: '#d97706', bg: '#fef9c3' },
                        { label: 'TOTAL', valor: contagem.TOTAL,     cor: '#1a2d5a', bg: '#e8edf6', bold: true },
                      ].map((item, i) => (
                        <div key={i} className="pv-resultado-item" style={{ background: item.bg }}>
                          <div className="pv-resultado-nome">
                            {i < 3 && <div className="pv-resultado-dot" style={{ background: item.cor }} />}
                            <span style={{ fontWeight: item.bold ? 800 : 600 }}>{item.label}</span>
                          </div>
                          <span className="pv-resultado-valor" style={{ color: item.cor }}>{String(item.valor).padStart(2,'0')}</span>
                        </div>
                      ))}
                    </div>
                    <div className="pv-como-votar">
                      <div className="pv-como-votar-titulo"><Vote size={11} color="#1e40af" /> PLACAR</div>
                      <p className="pv-como-votar-txt">Resultado parcial em tempo real da votação em andamento.</p>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
          {/* PLENARIUM:CARDS */}
          {aba === 'inicio' && <InicioCards comissoes={infoComissoes} leituras={mostraLeituras} usuario={usuario} sessao={sessao} pautaAtiva={pautaAtiva} jaVotou={jaVotou} isPresidente={isPresidente} setAba={setAba} onSenha={() => setModalSenha(true)} onFoto={() => setModalFoto(true)} onLogout={handleLogout} modoClaro={modoClaro} setModoClaro={setModoClaro} />}
          {aba !== 'votacao' && aba !== 'inicio' && <BarraSecao comissoes={infoComissoes} leituras={mostraLeituras} aba={aba} setAba={setAba} isPresidente={isPresidente} sessao={sessao} usuario={usuario} fotoExibida={fotoExibida} onOrdem={() => setVerOrdem(true)} />}
          {aba !== 'votacao' && aba !== 'inicio' && (
            <div className="pv-conteudo">
              {aba === 'todos' && <TodosProjetos />}
              {aba === 'documentos' && <CentralDocumentos modo="vereador" />} {/* PLENARIUM:CENTRAL_DOCUMENTOS */}
              {aba === 'leituras' && <LeiturasSecretario sessao={sessao} pautas={pautas} pautaAtiva={pautaAtiva} usuario={usuario} cargo={cargoReal || usuario?.cargo} />} {/* PLENARIUM:LEITURAS */}
              {aba === 'comissoes' && <ComissoesVereador usuario={usuario} />} {/* PLENARIUM:COMISSOES */}
              {aba === 'ata' && <AtaVereador usuario={usuario} />} {/* PLENARIUM:ATA_RETIFICACAO */}
              {aba === 'tribuna' && <TribunaVereador sessao={sessao} usuario={usuario} podeComandar={isPresidente} />} {/* PLENARIUM:TRIBUNA */}
              {aba === 'justificativas' && <JustificarFalta />} {/* PLENARIUM:JUSTIFICATIVA */}
              {aba === 'presencas' && <PresencaAoVivo sessaoId={sessao?.id} />}
              {aba === 'controle' && <ConteudoControle sessao={sessao} pautas={pautas} iniciarVotacao={iniciarVotacao} encerrarVotacao={encerrarVotacao} />}
              {aba === 'presenca' && <ConteudoPresenca presencas={presencas} loadingPresenca={loadingPresenca} buscarPresenca={buscarPresenca} />}
              {aba === 'cronometro' && <ConteudoCronometro vereadores={vereadores} filaOradores={filaOradores} abaFila={abaFila} setAbaFila={setAbaFila} adicionarNaFila={adicionarNaFila} removerDaFila={removerDaFila} moverFila={moverFila} atualizarTempoFila={atualizarTempoFila} iniciarDaFila={iniciarDaFila} nomeExterno={nomeExterno} setNomeExterno={setNomeExterno} tempoExterno={tempoExterno} setTempoExterno={setTempoExterno} adicionarExternoNaFila={adicionarExternoNaFila} cronometroAtivo={cronometroAtivo} tempoRestante={tempoRestante} cronometroNome={nomeOrador} pausarCronometro={pausarCronometro} pararCronometro={pararCronometro} adicionarTempo={adicionarTempo} cronometroPausado={cronometroPausado} />}
              {aba === 'ordem' && <ConteudoOrdem pautas={pautas} isPresidente={true} onReordenar={handleReordenar} onRetirar={handleRetirar} />}
              {aba === 'historico' && <SessoesAnteriores historico={historico} loadingHistorico={loadingHistorico} usuario={usuario} />} {/* PLENARIUM:CARDS v6 */}
              {aba === 'projetos' && <ConteudoProjetos meusProjetos={meusProjetos} loadingProjetos={loadingProjetos} filtroProjeto={filtroProjeto} setFiltroProjeto={setFiltroProjeto} projetosFiltrados={projetosFiltrados} expandidoProjeto={expandidoProjeto} setExpandidoProjeto={setExpandidoProjeto} setAba={setAba} />}
              {aba === 'requerimento' && <ConteudoRequerimento formReq={formReq} setFormReq={setFormReq} enviarRequerimento={enviarRequerimento} salvandoReq={salvandoReq} setAba={setAba} />}
            </div>
          )}
        </main>
      </div>

      <Modais confirmando={confirmando} setConfirmando={setConfirmando} confirmarVoto={confirmarVoto} votando={votando} pautaVoto={pautaAtiva} modalCronometro={modalCronometro} setModalCronometro={setModalCronometro} vereadores={vereadores} vereadorSelecionado={vereadorSelecionado} setVereadorSelecionado={setVereadorSelecionado} nomeOrador={nomeOrador} setNomeOrador={setNomeOrador} tempoOrador={tempoOrador} setTempoOrador={setTempoOrador} iniciarCronometro={iniciarCronometro} filaOradores={filaOradores} abaFila={abaFila} setAbaFila={setAbaFila} nomeExterno={nomeExterno} setNomeExterno={setNomeExterno} tempoExterno={tempoExterno} setTempoExterno={setTempoExterno} adicionarNaFila={adicionarNaFila} adicionarExternoNaFila={adicionarExternoNaFila} removerDaFila={removerDaFila} moverFila={moverFila} atualizarTempoFila={atualizarTempoFila} iniciarDaFila={iniciarDaFila} modalSenha={modalSenha} setModalSenha={setModalSenha} senhaAtual={senhaAtual} setSenhaAtual={setSenhaAtual} novaSenha={novaSenha} setNovaSenha={setNovaSenha} confirmarSenha={confirmarSenha} setConfirmarSenha={setConfirmarSenha} alterarSenha={alterarSenha} salvandoSenha={salvandoSenha} modalFoto={modalFoto} setModalFoto={setModalFoto} novaFoto={novaFoto} setNovaFoto={setNovaFoto} fotoExibida={fotoExibida} alterarFoto={alterarFoto} salvandoFoto={salvandoFoto} />

      <BotaoRoteiro sessao={sessao} /> {/* PLENARIUM:ROTEIRO_PRO -- roteiro no tablet do Presidente */}
      <AvisoSegundaChamada sessao={sessao} /> {/* PLENARIUM:DUAS_CHAMADAS */}

      <BottomBarMobile
        aba={aba} setAba={setAba}
        isPresidente={true}
        pautaAtiva={pautaAtiva}
        cronometroAtivo={cronometroAtivo}
        pautasPendentes={pautasPendentes}
        sessao={sessao}
        onCronometro={() => setModalCronometro(true)}
        onSenha={() => setModalSenha(true)}
        onLogout={handleLogout}
      />
    </div>
    </>
  );

  // ══════════════════════════════════════════
  // LAYOUT VEREADOR — novo design com CSS classes
  // ══════════════════════════════════════════
  return (
    <>
    <style>{mobileCSS}</style>
    <EleicaoMesaVereador sessaoId={sessao?.id} />
    <style>{CSS_CARDS}</style>
    <TelaPresenca sessaoId={sessao?.status === 'EM_ANDAMENTO' ? sessao.id : null} usuario={usuario} fotoExibida={fotoExibida} onLogout={handleLogout} />
    <AvisoResultado pautas={pautasAviso} /> {/* PLENARIUM:VOTACAO_BLOCO */}
    <CronometroTablet cron={cronometroSocket} vereadores={vereadores} usuario={usuario} votacaoAberta={!!pautaAtiva} /> {/* PLENARIUM:CRONOMETRO_TABLET */}
    <GavetaOrdem aberto={verOrdem} onFechar={() => setVerOrdem(false)} pautas={pautas} />
    <VoltarDoCelular aba={aba} setAba={setAba} verOrdem={verOrdem} setVerOrdem={setVerOrdem} /> {/* PLENARIUM:CARDS v5 */}
    <div className="pv-root pv-cards">

      {/* ════ CABEÇALHO CÂMARA ════ */}
      <div className="pv-cabecalho-camara" style={{ background: 'linear-gradient(90deg, #0f172a 0%, #1a2d5a 100%)', flexShrink: 0, borderBottom: '2px solid #2563eb' }}>

        {/* Header Desktop */}
        <div className="pv-header-desktop" style={{ padding: '10px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ width: 64, height: 64, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              {usuario?.camara?.logoUrl
                ? <img src={usuario.camara.logoUrl} alt="Logo" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                : <span style={{ fontSize: '1.32rem' }}>🏛️</span>
              }
            </div>
            <p style={{ color: 'white', fontSize: '1.32rem', fontWeight: 800, margin: 0 }}>
              {usuario?.camara?.nome || 'Câmara Municipal'}
            </p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
            <img src="/logo512.png" alt="Plenarium Digital" style={{ height: 32, objectFit: 'contain', mixBlendMode: 'screen' }} />
            <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.864rem', fontWeight: 700, letterSpacing: '0.5px' }}>PLENARIUM DIGITAL</span>
          </div>
        </div>

        {/* Header Mobile */}
        <div className="pv-header-mobile" style={{ display: 'none', flexDirection: 'column', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
          <div style={{ padding: '8px 14px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
            <div className="pv-brasao" style={{ width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {usuario?.camara?.logoUrl
                ? <img src={usuario.camara.logoUrl} alt="Logo" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                : <span style={{ fontSize: '1.2rem' }}>🏛️</span>
              }
            </div>
            <span style={{ color: 'white', fontSize: '0.9rem', fontWeight: 700 }}>{usuario?.camara?.nome || 'Câmara Municipal'}</span>
          </div>
          <div style={{ padding: '8px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>

              <div>
                <p style={{ color: 'white', fontSize: '0.864rem', fontWeight: 700, margin: '0 0 1px' }}>{exibCurto(usuario)}</p>
                <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.744rem', margin: 0 }}>{usuario?.partido}</p>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
              <img src="/logo512.png" alt="Plenarium Digital" style={{ height: 24, objectFit: 'contain', mixBlendMode: 'screen' }} />
              <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.696rem', fontWeight: 700, letterSpacing: '0.4px', lineHeight: 1.3 }}>PLENARIUM<br/>DIGITAL</span>
            </div>
          </div>
        </div>

        <div style={{ padding: '6px 20px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
          <div style={{ width: 6, height: 6, borderRadius: '50%', background: sessao ? '#22c55e' : '#64748b', flexShrink: 0, animation: sessao ? 'pulse 1.4s ease infinite' : 'none' }} />
          <span style={{ color: 'rgba(255,255,255,0.65)', fontSize: '0.816rem', fontWeight: 600, letterSpacing: '0.3px' }}>
            {sessao ? `SESSÃO EM ANDAMENTO — ${sessao.titulo}` : 'AGUARDANDO SESSÃO'}
          </span>
        </div>
      </div>

      <div className="pv-body">

        {/* ════ SIDEBAR ════ */}
        <aside className="pv-sidebar">


          <nav className="pv-nav">
            <button className={`pv-nav-item ${aba === 'votacao' ? 'ativo' : ''}`} onClick={() => setAba('votacao')}>
              <Vote size={15} /> Votação
              {pautaAtiva && <span className="pv-nav-badge" />}
            </button>
            <button className={`pv-nav-item ${aba === 'ordem' ? 'ativo' : ''}`} onClick={() => setAba('ordem')}>
              <Calendar size={15} /> Ordem do Dia
            </button>
            <button className={`pv-nav-item ${aba === 'historico' ? 'ativo' : ''}`} onClick={() => setAba('historico')}>
              <History size={15} /> Sessões
            </button>
            <button className={`pv-nav-item ${aba === 'projetos' ? 'ativo' : ''}`} onClick={() => setAba('projetos')}>
              <FileText size={15} /> Meus Projetos
            </button>
            <button className={`pv-nav-item ${aba === 'requerimento' ? 'ativo' : ''}`} onClick={() => setAba('requerimento')}>
              <Plus size={15} /> Requerimento
            </button>
            {/* PLENARIUM:RECARREGAR */}
            <button className="pv-nav-item" onClick={() => window.location.reload()}>
              <RefreshCw size={15} /> Recarregar tela
            </button>
            <button className="pv-nav-item" onClick={() => setModalSenha(true)}>
              <KeyRound size={15} /> Alterar Senha
            </button>
          </nav>

          <div className="pv-sair">
            <button onClick={() => setModoClaro(m => !m)} style={{ marginBottom: 6, background: modoClaro ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.15)', color: modoClaro ? '#fbbf24' : 'rgba(255,255,255,0.6)', borderRadius: 8, padding: '7px', width: '100%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, fontSize: '0.9rem', fontWeight: 600, fontFamily: 'Inter, sans-serif' }}>
              {modoClaro ? <Moon size={13} /> : <Sun size={13} />} {modoClaro ? 'Modo Escuro' : 'Modo Claro'}
            </button>
            <button onClick={handleLogout}><LogOut size={14} /> Sair</button>
          </div>
        </aside>

        {/* ════ ÁREA PRINCIPAL ════ */}
        <main className="pv-main">

          {/* ── ABA VOTAÇÃO ── */}
          {aba === 'votacao' && (
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
              <BarraSecao comissoes={infoComissoes} leituras={mostraLeituras} aba={aba} setAba={setAba} isPresidente={isPresidente} sessao={sessao} usuario={usuario} fotoExibida={fotoExibida} onOrdem={() => setVerOrdem(true)} pautaAtiva={pautaAtiva} /> {/* PLENARIUM:CARDS */}
              {!sessao ? (
                <TelaSemSessaoCards historico={historico} usuario={usuario} fotoExibida={fotoExibida} /> /* PLENARIUM:CARDS v4 */
              ) : !pautaAtiva ? (
                <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px', background: '#f8fafc', display: 'flex', flexDirection: 'column', gap: 16 }}>

                  {/* Foto do vereador */}
                  <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: 12, padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 16 }}>
                    <div style={{ width: 72, height: 72, borderRadius: 10, overflow: 'hidden', border: '2px solid #e2e8f0', flexShrink: 0, background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {fotoExibida
                        ? <img src={fotoExibida} alt={usuario?.nome} style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top' }} />
                        : <span style={{ fontSize: 24, fontWeight: 700, color: '#94a3b8' }}>{usuario?.nome?.split(' ').map(n => n[0]).slice(0,2).join('') || '?'}</span>
                      }
                    </div>
                    <div>
                      <div style={{ fontSize: 11, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 3 }}>Bem-vindo(a)</div>
                      <div style={{ fontSize: 18, fontWeight: 800, color: '#0f172a' }}>{exib(usuario) || 'Vereador'}</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
                        <span style={{ fontSize: 11, background: '#eff6ff', color: '#1d4ed8', padding: '2px 10px', borderRadius: 20, fontWeight: 600 }}>{tratamento(usuario)}</span>
                        {usuario?.partido && <span style={{ fontSize: 11, color: '#94a3b8' }}>{usuario.partido}</span>}
                      </div>
                    </div>
                  </div>

                  {/* Header da sessão */}
                  <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: 12, padding: '16px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                      <div style={{ width: 44, height: 44, borderRadius: 10, background: '#eff6ff', border: '1.5px solid #bfdbfe', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <Calendar size={22} color="#3b82f6" />
                      </div>
                      <div>
                        <div style={{ fontWeight: 800, color: '#0f172a', fontSize: '1.2rem' }}>{sessao.titulo}</div>
                        <div style={{ fontSize: '0.936rem', color: '#64748b', marginTop: 2 }}>
                          {new Date(sessao.data).toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' })} • {new Date().toLocaleTimeString('pt-BR')}
                        </div>
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 12 }}>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '0.84rem', fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'flex', alignItems: 'center', gap: 4 }}><Users size={11} color="#64748b" /> Presenças</div>
                        <div style={{ fontSize: '1.32rem', fontWeight: 800, color: '#1d4ed8' }}>{totalPresentes} / {vereadores.length}</div>
                        <div style={{ fontSize: '0.78rem', color: '#94a3b8' }}>Vereadores presentes</div>
                      </div>
                      <div style={{ width: 1, background: '#e2e8f0' }} />
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '0.84rem', fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'flex', alignItems: 'center', gap: 4 }}><CheckCircle size={11} color="#64748b" /> Quórum</div>
                        <div style={{ fontSize: '1.32rem', fontWeight: 800, color: totalPresentes >= quorumMinimo ? '#16a34a' : '#dc2626' }}>{totalPresentes >= quorumMinimo ? 'OK' : 'NOK'}</div>
                        <div style={{ fontSize: '0.78rem', color: '#94a3b8' }}>{totalPresentes >= quorumMinimo ? 'Quórum atingido' : 'Quórum insuficiente'}</div>
                      </div>
                      <div style={{ width: 1, background: '#e2e8f0' }} />
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                          <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#dc2626', animation: 'pulse 1.4s ease infinite' }} />
                          <div style={{ fontSize: '0.84rem', fontWeight: 700, color: '#dc2626', textTransform: 'uppercase' }}>AO VIVO</div>
                        </div>
                        <div style={{ fontSize: '0.78rem', color: '#94a3b8', marginTop: 2 }}>Transmissão plenária</div>
                      </div>
                    </div>
                  </div>

                  <CartaoPresenca sessaoId={sessao?.id} />
                  {/* Aguardando votação */}
                  <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 12, padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#3b82f6', animation: 'pulse 1.4s ease infinite', flexShrink: 0 }} />
                    <span style={{ fontSize: '1.02rem', color: '#1d4ed8', fontWeight: 600 }}>Aguardando abertura de votação pelo presidente da sessão</span>
                  </div>
                  <VotosDosVereadores pautaAtiva={null} jaVotou={false} sessaoId={sessao?.id} pautas={pautas} /> {/* PLENARIUM:VOTOS_AO_VIVO -- resultado da ultima, ate abrir a proxima */}
                  <MudarMeuVoto sessao={sessao} /> {/* PLENARIUM:MUDANCA_VOTO */}

                  {/* Atividade na sessão atual + Parlamentar — OCULTOS a pedido em 19/08/2026.
                      Estavam poluindo a tela inicial da sessão. O código foi mantido inteiro
                      (só a exibição está desligada pela condição false abaixo), porque o
                      cálculo servirá de base ao futuro gerador de relatórios.
                      Para voltar a exibir, troque false por true. */}
                  {false && (
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>

                    {/* Atividade na sessão atual */}
                    <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: 12, padding: '18px 20px' }}>
                      <div style={{ fontSize: '0.9rem', fontWeight: 800, color: '#0f172a', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 4 }}>ATIVIDADE NA SESSÃO ATUAL</div>
                      <div style={{ width: 32, height: 3, background: '#eab308', borderRadius: 99, marginBottom: 16 }} />
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
                        {[
                          { icon: <Vote size={18} color={"currentColor"} />, value: sessao.pautas?.filter(p => p.status !== 'PENDENTE').length || 0, label: 'Votações', sub: 'Participou', color: '#4338ca', bg: '#ede9fe' },
                          { icon: <CheckCircle size={18} color={"currentColor"} />, value: `${totalPresentes >= vereadores.length ? '100' : Math.round((totalPresentes/Math.max(vereadores.length,1))*100)}%`, label: 'Presenças', sub: 'Na sessão', color: '#16a34a', bg: '#dcfce7' },
                          { icon: <Mic size={18} color={"currentColor"} />, value: meusDiscursos.filter(d => d.sessaoId === sessao?.id).length, label: 'Discursos', sub: 'Realizados', color: '#7c3aed', bg: '#ede9fe' },
                          { icon: <FileText size={18} color={"currentColor"} />, value: meusProjetos.filter(p => p.tipo === 'Requerimento').length, label: 'Requerimentos', sub: 'Apresentados', color: '#d97706', bg: '#fef9c3' },
                        ].map((c, i) => (
                          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#f8fafc', borderRadius: 10, padding: '10px 12px', border: '1px solid #f1f5f9' }}>
                            <div style={{ width: 36, height: 36, borderRadius: 8, background: c.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{c.icon}</div>
                            <div>
                              <div style={{ fontSize: '1.32rem', fontWeight: 800, color: c.color, lineHeight: 1 }}>{c.value}</div>
                              <div style={{ fontSize: '0.864rem', fontWeight: 600, color: '#334155' }}>{c.label}</div>
                              <div style={{ fontSize: '0.78rem', color: '#94a3b8' }}>{c.sub}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div style={{ background: '#eff6ff', borderRadius: 8, padding: '10px 14px', fontSize: '0.936rem', color: '#1d4ed8', fontWeight: 500, display: 'flex', alignItems: 'center', gap: 6 }}>
                        Você está conectado e participando desta sessão.
                      </div>
                    </div>

                    {/* Atividade parlamentar */}
                    <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: 12, padding: '18px 20px' }}>
                      <div style={{ fontSize: '0.9rem', fontWeight: 800, color: '#0f172a', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 4 }}>ATIVIDADE PARLAMENTAR</div>
                      <div style={{ width: 32, height: 3, background: '#eab308', borderRadius: 99, marginBottom: 16 }} />
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
                        {[
                          { icon: <Vote size={18} color={"currentColor"} />, value: historico.reduce((a, s) => a + (s.pautas?.length || 0), 0), label: 'Votações', sub: 'Participou', color: '#4338ca', bg: '#ede9fe' },
                          { icon: <Mic size={18} color={"currentColor"} />, value: meusDiscursos.length, label: 'Discursos', sub: 'Realizados', color: '#7c3aed', bg: '#ede9fe' },
                          { icon: <FileText size={18} color={"currentColor"} />, value: meusProjetos.filter(p => p.tipo === 'Requerimento').length, label: 'Requerimentos', sub: 'Apresentados', color: '#d97706', bg: '#fef9c3' },
                          { icon: <ClipboardList size={18} color={"currentColor"} />, value: meusProjetos.length, label: 'Projetos', sub: 'Apoiados', color: '#16a34a', bg: '#dcfce7' },
                        ].map((c, i) => (
                          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#f8fafc', borderRadius: 10, padding: '10px 12px', border: '1px solid #f1f5f9' }}>
                            <div style={{ width: 36, height: 36, borderRadius: 8, background: c.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{c.icon}</div>
                            <div>
                              <div style={{ fontSize: '1.32rem', fontWeight: 800, color: c.color, lineHeight: 1 }}>{c.value}</div>
                              <div style={{ fontSize: '0.864rem', fontWeight: 600, color: '#334155' }}>{c.label}</div>
                              <div style={{ fontSize: '0.78rem', color: '#94a3b8' }}>{c.sub}</div>
                            </div>
                          </div>
                        ))}
                      </div>

                    </div>
                  </div>
                  )}
                </div>
              ) : (
                <div className="pv-votacao">

                  {/* Centro */}
                  <div className="pv-votacao-centro">

                    {/* Card pauta */}
                    <div className="pv-pauta-card">
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
                        <span className="pv-pauta-tag">{membrosBloco.length ? 'VOTAÇÃO EM BLOCO' : 'PROJETO EM VOTAÇÃO'}</span>
                        <span className="pv-pauta-numero">{membrosBloco.length ? `${membrosBloco.length + 1} matérias` : pautaAtiva.numero}</span>
                      </div>
                      <div className="pv-pauta-body">
                        <div style={{ flex: 1, minWidth: 140 }}>
                          {membrosBloco.length ? <ListaBloco itens={[pautaAtiva, ...membrosBloco]} /> : (<>
                            <h3 className="pv-pauta-titulo">{pautaAtiva.titulo}</h3>
                            <p className="pv-pauta-subtipo">{TIPO_LABEL[pautaAtiva.tipo]}</p>
                            {pautaAtiva.projetoId && <PareceresResumo projetoId={pautaAtiva.projetoId} />} {/* PLENARIUM:COMISSOES */}
                            {pautaAtiva.tipo === 'ATA_ANTERIOR' && pautaAtiva.retificacao && <div style={{ marginTop: 8, background: '#fef3c7', color: '#78350f', borderRadius: 10, padding: '8px 12px', whiteSpace: 'pre-wrap', fontSize: '.92rem', lineHeight: 1.45 }}><b>Com retificação:</b>{'\n'}{pautaAtiva.retificacao}</div>} {/* PLENARIUM:ATA_RETIFICACAO */}
                          </>)}
                        </div>
                      </div>
                    </div>

                    {/* Stats */}

                    {/* Botões voto ou confirmação */}
                    {!jaVotou ? (
                      <>
                        <p className="pv-como-votar-label" style={{ display: 'none', textAlign: 'center', color: '#475569', fontSize: '1.02rem', fontWeight: 500, margin: '4px 0 8px' }}>Como deseja votar?</p>
                        {meuVoto && <p style={{ textAlign: 'center', color: '#0f172a', fontSize: '1rem', fontWeight: 600, margin: '4px 0 10px' }}>Seu voto atual: <b>{meuVoto === 'SIM' ? 'SIM' : meuVoto === 'NAO' ? 'NÃO' : 'ABSTENÇÃO'}</b>. Toque no novo voto ou <button type="button" onClick={() => setJaVotou(true)} style={{ border: 0, background: 'none', color: '#2563eb', fontWeight: 800, fontSize: '1rem', cursor: 'pointer', textDecoration: 'underline', padding: 0, fontFamily: 'inherit' }}>manter</button>.</p>}{/* PLENARIUM:TROCA_VOTO */}
                        <div className="pv-botoes-voto">
                          <button className="pv-btn-voto pv-btn-sim" onClick={() => votar('SIM')} disabled={votando}>
                            <CheckCircle size={22} /> SIM
                          </button>
                          <button className="pv-btn-voto pv-btn-nao" onClick={() => votar('NAO')} disabled={votando}>
                            <XCircle size={22} /> NÃO
                          </button>
                          <button className="pv-btn-voto pv-btn-abst" onClick={() => votar('ABSTENCAO')} disabled={votando}>
                            <MinusCircle size={22} /> ABSTENÇÃO
                          </button>
                        </div>
                      </>
                    ) : (
                      <div className="pv-voto-ok" style={{
                        background: meuVoto === 'SIM' ? '#dcfce7' : meuVoto === 'NAO' ? '#fee2e2' : '#f1f5f9',
                        borderColor: meuVoto === 'SIM' ? '#16a34a' : meuVoto === 'NAO' ? '#dc2626' : '#cbd5e1',
                      }}>
                        <span style={{ fontSize: '2.16rem' }}>{meuVoto === 'SIM' ? '✅' : meuVoto === 'NAO' ? '❌' : '⚪'}</span>
                        <div>
                          <p style={{ fontWeight: 800, fontSize: '1.056rem', color: '#0f172a', margin: '0 0 2px' }}>SEU VOTO FOI REGISTRADO!</p>
                          <p style={{ color: '#64748b', fontSize: '0.9rem', margin: 0 }}>Aguardando resultado final da votação.</p>
                          <button type="button" className="pv-alterar-voto" onClick={() => setJaVotou(false)} style={{ marginTop: 8, padding: '8px 14px', borderRadius: 10, border: '1px solid #94a3b8', background: '#fff', color: '#0f172a', fontWeight: 700, fontSize: '.9rem', cursor: 'pointer', fontFamily: 'inherit' }}>Votei errado: alterar meu voto</button>{/* PLENARIUM:TROCA_VOTO */}
                        </div>
                      </div>
                    )}

                    {/* Resultado parcial — só mobile */}
                    <div className="pv-resultado-mobile" style={{ display: 'none', background: 'white', borderRadius: 12, padding: 12, border: '0.5px solid #e2e8f0', marginTop: 4 }}>
                      <p style={{ color: '#64748b', fontSize: '0.84rem', fontWeight: 700, letterSpacing: '0.5px', margin: '0 0 8px', textTransform: 'uppercase' }}>Resultado Parcial</p>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 6 }}>
                        {[
                          { label: 'SIM',   valor: contagem.SIM,       cor: '#15803d', bg: '#f0fdf4', border: '#bbf7d0' },
                          { label: 'NÃO',   valor: contagem.NAO,       cor: '#b91c1c', bg: '#fef2f2', border: '#fecaca' },
                          { label: 'ABST.', valor: contagem.ABSTENCAO, cor: '#b45309', bg: '#fffbeb', border: '#fde68a' },
                          { label: 'TOTAL', valor: contagem.TOTAL,     cor: '#0f172a', bg: '#f8fafc', border: '#e2e8f0' },
                        ].map((item, i) => (
                          <div key={i} style={{ background: item.bg, borderRadius: 8, padding: '8px 4px', textAlign: 'center', border: `0.5px solid ${item.border}` }}>
                            <p style={{ color: item.cor, fontSize: '0.78rem', fontWeight: 700, margin: '0 0 3px' }}>{item.label}</p>
                            <p style={{ color: item.cor, fontSize: '1.44rem', fontWeight: 800, margin: 0 }}>{String(item.valor || 0).padStart(2, '0')}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                    <VotosDosVereadores pautaAtiva={pautaAtiva} jaVotou={jaVotou} sessaoId={sessao?.id} pautas={pautas} meuId={usuario?.id} meuVoto={meuVoto} /> {/* PLENARIUM:VOTOS_AO_VIVO -- abaixo do resultado parcial */}

                    {/* Ordem do dia */}
                  </div>

                  {/* Painel lateral */}
                  <div className="pv-lateral">
                    <div>
                      <div className="pv-lateral-titulo">
                        <div className="pv-lateral-linha" />
                        <span className="pv-lateral-label">Resultado Parcial</span>
                      </div>
                      {[
                        { label: 'SIM',   valor: contagem.SIM,       cor: '#16a34a', bg: '#dcfce7' },
                        { label: 'NÃO',   valor: contagem.NAO,       cor: '#dc2626', bg: '#fee2e2' },
                        { label: 'ABST.', valor: contagem.ABSTENCAO, cor: '#d97706', bg: '#fef9c3' },
                        { label: 'TOTAL', valor: contagem.TOTAL,     cor: '#1a2d5a', bg: '#e8edf6', bold: true },
                      ].map((item, i) => (
                        <div key={i} className="pv-resultado-item" style={{ background: item.bg }}>
                          <div className="pv-resultado-nome">
                            {i < 3 && <div className="pv-resultado-dot" style={{ background: item.cor }} />}
                            <span style={{ fontWeight: item.bold ? 800 : 600 }}>{item.label}</span>
                          </div>
                          <span className="pv-resultado-valor" style={{ color: item.cor }}>{String(item.valor).padStart(2,'0')}</span>
                        </div>
                      ))}
                    </div>
                    <div className="pv-como-votar">
                      <div className="pv-como-votar-titulo">
                        <Vote size={11} color="#1e40af" /> COMO VOTAR
                      </div>
                      <p className="pv-como-votar-txt">Selecione uma das opções acima para registrar seu voto. Após votar, aguarde o resultado final.</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* ── OUTRAS ABAS ── */}
          {/* PLENARIUM:CARDS */}
          {aba === 'inicio' && <InicioCards comissoes={infoComissoes} leituras={mostraLeituras} usuario={usuario} sessao={sessao} pautaAtiva={pautaAtiva} jaVotou={jaVotou} isPresidente={isPresidente} setAba={setAba} onSenha={() => setModalSenha(true)} onFoto={() => setModalFoto(true)} onLogout={handleLogout} modoClaro={modoClaro} setModoClaro={setModoClaro} />}
          {aba !== 'votacao' && aba !== 'inicio' && <BarraSecao comissoes={infoComissoes} leituras={mostraLeituras} aba={aba} setAba={setAba} isPresidente={isPresidente} sessao={sessao} usuario={usuario} fotoExibida={fotoExibida} onOrdem={() => setVerOrdem(true)} />}
          {aba !== 'votacao' && aba !== 'inicio' && (
            <div className="pv-conteudo">
              {aba === 'todos' && <TodosProjetos />}
              {aba === 'documentos' && <CentralDocumentos modo="vereador" />} {/* PLENARIUM:CENTRAL_DOCUMENTOS */}
              {aba === 'leituras' && <LeiturasSecretario sessao={sessao} pautas={pautas} pautaAtiva={pautaAtiva} usuario={usuario} cargo={cargoReal || usuario?.cargo} />} {/* PLENARIUM:LEITURAS */}
              {aba === 'comissoes' && <ComissoesVereador usuario={usuario} />} {/* PLENARIUM:COMISSOES */}
              {aba === 'ata' && <AtaVereador usuario={usuario} />} {/* PLENARIUM:ATA_RETIFICACAO */}
              {aba === 'tribuna' && <TribunaVereador sessao={sessao} usuario={usuario} podeComandar={isPresidente} />} {/* PLENARIUM:TRIBUNA */}
              {aba === 'justificativas' && <JustificarFalta />} {/* PLENARIUM:JUSTIFICATIVA */}
              {aba === 'presencas' && <PresencaAoVivo sessaoId={sessao?.id} />}
              {aba === 'ordem' && <ConteudoOrdem pautas={pautas} isPresidente={false} />}
              {aba === 'historico' && <SessoesAnteriores historico={historico} loadingHistorico={loadingHistorico} usuario={usuario} />} {/* PLENARIUM:CARDS v6 */}
              {aba === 'projetos' && <ConteudoProjetos meusProjetos={meusProjetos} loadingProjetos={loadingProjetos} filtroProjeto={filtroProjeto} setFiltroProjeto={setFiltroProjeto} projetosFiltrados={projetosFiltrados} expandidoProjeto={expandidoProjeto} setExpandidoProjeto={setExpandidoProjeto} setAba={setAba} />}
              {aba === 'requerimento' && <ConteudoRequerimento formReq={formReq} setFormReq={setFormReq} enviarRequerimento={enviarRequerimento} salvandoReq={salvandoReq} setAba={setAba} />}
            </div>
          )}
        </main>
      </div>

      {/* MODAIS */}
      <Modais confirmando={confirmando} setConfirmando={setConfirmando} confirmarVoto={confirmarVoto} votando={votando} pautaVoto={pautaAtiva} modalCronometro={modalCronometro} setModalCronometro={setModalCronometro} vereadores={vereadores} vereadorSelecionado={vereadorSelecionado} setVereadorSelecionado={setVereadorSelecionado} nomeOrador={nomeOrador} setNomeOrador={setNomeOrador} tempoOrador={tempoOrador} setTempoOrador={setTempoOrador} iniciarCronometro={iniciarCronometro} filaOradores={filaOradores} abaFila={abaFila} setAbaFila={setAbaFila} nomeExterno={nomeExterno} setNomeExterno={setNomeExterno} tempoExterno={tempoExterno} setTempoExterno={setTempoExterno} adicionarNaFila={adicionarNaFila} adicionarExternoNaFila={adicionarExternoNaFila} removerDaFila={removerDaFila} moverFila={moverFila} atualizarTempoFila={atualizarTempoFila} iniciarDaFila={iniciarDaFila} modalSenha={modalSenha} setModalSenha={setModalSenha} senhaAtual={senhaAtual} setSenhaAtual={setSenhaAtual} novaSenha={novaSenha} setNovaSenha={setNovaSenha} confirmarSenha={confirmarSenha} setConfirmarSenha={setConfirmarSenha} alterarSenha={alterarSenha} salvandoSenha={salvandoSenha} modalFoto={modalFoto} setModalFoto={setModalFoto} novaFoto={novaFoto} setNovaFoto={setNovaFoto} fotoExibida={fotoExibida} alterarFoto={alterarFoto} salvandoFoto={salvandoFoto} />

      <AvisoSegundaChamada sessao={sessao} /> {/* PLENARIUM:DUAS_CHAMADAS */}

      <BottomBarMobile
        aba={aba} setAba={setAba}
        isPresidente={false}
        pautaAtiva={pautaAtiva}
        onSenha={() => setModalSenha(true)}
        onLogout={handleLogout}
      />
    </div>
    </>
  );
}

// ══════════════════════════════════════════
// COMPONENTES COMPARTILHADOS
// ══════════════════════════════════════════

function ConteudoVotacaoSimples({ sessao, pautaAtiva, jaVotou, meuVoto, votando, votar, historico, meusProjetos }) {
  if (!sessao) return <TelaSemSessao historico={historico} meusProjetos={meusProjetos} usuario={usuario} fotoExibida={fotoExibida} />;
  if (!pautaAtiva) return (
    <div style={{ background: 'white', borderRadius: 16, padding: 40, textAlign: 'center', border: '1px solid #e2e8f0' }}>
      <Clock size={40} style={{ margin: '0 auto 12px', display: 'block', color: '#cbd5e1' }} />
      <p style={{ fontWeight: 700, color: '#0f172a', marginBottom: 4, fontSize: '1.2rem' }}>{sessao.titulo}</p>
      <p style={{ color: '#94a3b8', fontSize: '1.02rem' }}>Aguardando abertura de votação...</p>
    </div>
  );
  return (
    <div style={{ background: 'white', borderRadius: 16, padding: 24, border: '2px solid #dc2626' }}>
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#fee2e2', color: '#dc2626', padding: '4px 12px', borderRadius: 999, fontSize: '0.864rem', fontWeight: 800, marginBottom: 12 }}>
        <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#dc2626', display: 'inline-block', animation: 'pulse 1.4s ease infinite' }} /> EM VOTAÇÃO
      </div>
      <h2 style={{ fontSize: '1.32rem', fontWeight: 800, color: '#0f172a', marginBottom: 8 }}>{pautaAtiva.titulo}</h2>
      {pautaAtiva.descricao && <p style={{ color: '#64748b', fontSize: '1.02rem', marginBottom: 20 }}>{pautaAtiva.descricao}</p>}
      {jaVotou ? (
        <div style={{ background: meuVoto === 'SIM' ? '#dcfce7' : meuVoto === 'NAO' ? '#fee2e2' : '#f1f5f9', border: `2px solid ${meuVoto === 'SIM' ? '#16a34a' : meuVoto === 'NAO' ? '#dc2626' : '#cbd5e1'}`, borderRadius: 12, padding: 24, textAlign: 'center' }}>
          <div style={{ fontSize: '3rem', marginBottom: 8 }}>{meuVoto === 'SIM' ? '✅' : meuVoto === 'NAO' ? '❌' : '⚪'}</div>
          <p style={{ fontWeight: 800, fontSize: '1.2rem', color: '#0f172a', marginBottom: 4 }}>Voto: {meuVoto === 'SIM' ? 'SIM' : meuVoto === 'NAO' ? 'NÃO' : 'ABSTENÇÃO'}</p>
        </div>
      ) : (
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={() => votar('SIM')} disabled={votando} style={{ flex: 1, padding: '16px', borderRadius: 12, border: 'none', background: '#16a34a', color: 'white', fontSize: '1.2rem', fontWeight: 800, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, fontFamily: 'inherit' }}>
            <CheckCircle size={20} /> SIM
          </button>
          <button onClick={() => votar('NAO')} disabled={votando} style={{ flex: 1, padding: '16px', borderRadius: 12, border: 'none', background: '#dc2626', color: 'white', fontSize: '1.2rem', fontWeight: 800, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, fontFamily: 'inherit' }}>
            <XCircle size={20} /> NÃO
          </button>
          <button onClick={() => votar('ABSTENCAO')} disabled={votando} style={{ flex: 1, padding: '16px', borderRadius: 12, border: '1px solid #e2e8f0', background: '#f8fafc', color: '#475569', fontSize: '1.2rem', fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, fontFamily: 'inherit' }}>
            <MinusCircle size={20} /> ABSTENÇÃO
          </button>
        </div>
      )}
    </div>
  );
}

function ConteudoControle({ sessao, pautas, iniciarVotacao, encerrarVotacao }) {
  return (
    <div>
      <h2 style={{ fontSize: '1.2rem', fontWeight: 800, color: '#0f172a', margin: '0 0 14px' }}>Controle de Votação</h2>
      {!sessao
        ? <div style={{ background: 'white', borderRadius: 12, padding: 40, textAlign: 'center', border: '1px solid #e2e8f0' }}><p style={{ color: '#64748b' }}>Nenhuma sessão em andamento.</p></div>
        : pautas.map((p, i) => {
          const sim  = p.votos?.filter(v => v.opcao === 'SIM').length || 0;
          const nao  = p.votos?.filter(v => v.opcao === 'NAO').length || 0;
          const abs  = p.votos?.filter(v => v.opcao === 'ABSTENCAO').length || 0;
          const total = sim + nao + abs;
          const emV   = p.status === 'EM_VOTACAO';
          const aprov = p.status === 'APROVADA';
          const reprov = p.status === 'REPROVADA';
          const corBorda = emV ? '#dc2626' : aprov ? '#16a34a' : reprov ? '#dc2626' : '#e2e8f0';
          const statusLabel = emV ? 'EM VOTAÇÃO' : aprov ? 'APROVADA' : reprov ? 'REPROVADA' : 'PENDENTE';
          const statusBg  = emV ? '#fee2e2' : aprov ? '#dcfce7' : reprov ? '#fee2e2' : '#f1f5f9';
          const statusCor = emV ? '#dc2626' : aprov ? '#15803d' : reprov ? '#b91c1c' : '#64748b';
          return (
            <div key={p.id} style={{ background: 'white', borderRadius: 12, padding: '14px 20px', marginBottom: 8, border: '1px solid #e2e8f0', borderLeft: `4px solid ${corBorda}` }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16 }}>

                {/* Número + título */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, flex: 1, minWidth: 0 }}>
                  <div style={{ width: 28, height: 28, borderRadius: 6, background: emV ? '#dc2626' : '#1a2d5a', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <span style={{ color: 'white', fontSize: '0.84rem', fontWeight: 800 }}>{String(i+1).padStart(2,'0')}</span>
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <p style={{ fontWeight: 700, fontSize: '1.02rem', color: '#0f172a', margin: '0 0 2px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.numero} — {p.titulo}</p>
                    <p style={{ fontSize: '0.84rem', color: '#94a3b8', margin: 0 }}>{TIPO_LABEL[p.tipo] || p.tipo}</p>
                  </div>
                </div>

                {/* Placar de votos */}
                {total > 0 && (
                  <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4, background: '#dcfce7', borderRadius: 6, padding: '3px 8px' }}>
                      <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#16a34a' }} />
                      <span style={{ fontSize: '0.864rem', fontWeight: 700, color: '#15803d' }}>SIM {sim}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4, background: '#fee2e2', borderRadius: 6, padding: '3px 8px' }}>
                      <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#dc2626' }} />
                      <span style={{ fontSize: '0.864rem', fontWeight: 700, color: '#b91c1c' }}>NÃO {nao}</span>
                    </div>
                    {abs > 0 && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 4, background: '#fef9c3', borderRadius: 6, padding: '3px 8px' }}>
                        <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#d97706' }} />
                        <span style={{ fontSize: '0.864rem', fontWeight: 700, color: '#92400e' }}>ABST {abs}</span>
                      </div>
                    )}
                  </div>
                )}

                {/* Status */}
                <span style={{ background: statusBg, color: statusCor, fontSize: '0.78rem', fontWeight: 700, padding: '3px 10px', borderRadius: 6, flexShrink: 0, letterSpacing: 0.3 }}>{statusLabel}</span>

                {/* Ação */}
                <div style={{ flexShrink: 0 }}>
                  {p.status === 'PENDENTE' && (
                    <button onClick={() => iniciarVotacao(p.id)} style={{ background: '#2563eb', border: 'none', color: 'white', padding: '7px 14px', borderRadius: 8, cursor: 'pointer', fontSize: '0.936rem', fontWeight: 700, display: 'flex', alignItems: 'center', gap: 5 }}>
                      <Play size={13} /> Iniciar
                    </button>
                  )}
                  {p.status === 'EM_VOTACAO' && (
                    <button onClick={() => encerrarVotacao(p)} style={{ background: '#dc2626', border: 'none', color: 'white', padding: '7px 14px', borderRadius: 8, cursor: 'pointer', fontSize: '0.936rem', fontWeight: 700, display: 'flex', alignItems: 'center', gap: 5 }}>
                      <Square size={13} /> Encerrar
                    </button>
                  )}
                </div>
              </div>
            </div>
          );
        })
      }
    </div>
  );
}


function ConteudoCronometro({ vereadores, filaOradores, abaFila, setAbaFila, adicionarNaFila, removerDaFila, moverFila, atualizarTempoFila, iniciarDaFila, nomeExterno, setNomeExterno, tempoExterno, setTempoExterno, adicionarExternoNaFila, cronometroAtivo, tempoRestante, cronometroNome, pausarCronometro, pararCronometro, adicionarTempo, cronometroPausado }) {
  const cronometroFoto = vereadores.find(v => v.nome === cronometroNome)?.fotoUrl || null;
  const fmt = (s) => `${String(Math.floor(s/60)).padStart(2,'0')}:${String(s%60).padStart(2,'0')}`;
  return (
    <div style={{ display: 'flex', gap: 0, height: '100%' }}>

      {/* Coluna esquerda - vereadores/fila/externo */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', borderRight: '1px solid #e2e8f0' }}>
        {/* Abas */}
        <div style={{ display: 'flex', gap: 8, padding: '12px 16px', borderBottom: '1px solid #e2e8f0', background: '#f8fafc', flexShrink: 0 }}>
          {[
            { id: 'vereadores', label: 'Vereadores' },
            { id: 'fila', label: `Fila de oradores${filaOradores.length > 0 ? ` (${filaOradores.length})` : ''}` },
            { id: 'externo', label: '+ Orador externo' },
          ].map(tab => (
            <button key={tab.id} onClick={() => setAbaFila(tab.id)} style={{ padding: '5px 14px', borderRadius: 20, fontSize: 12, fontWeight: 500, border: '1px solid', borderColor: abaFila === tab.id ? '#0f172a' : '#e2e8f0', background: abaFila === tab.id ? '#0f172a' : 'white', color: abaFila === tab.id ? 'white' : '#64748b', cursor: 'pointer' }}>
              {tab.label}
            </button>
          ))}
        </div>

        {/* Vereadores */}
        {abaFila === 'vereadores' && (
          <div style={{ flex: 1, overflowY: 'auto', padding: 16 }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 12 }}>
              {vereadores.map(v => (
                <div key={v.id} style={{ border: '1px solid #e2e8f0', borderRadius: 12, overflow: 'hidden', background: 'white', boxShadow: '0 1px 3px rgba(0,0,0,0.06)', transition: 'all 0.15s' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor='#3b82f6'; e.currentTarget.style.boxShadow='0 4px 12px rgba(59,130,246,0.15)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor='#e2e8f0'; e.currentTarget.style.boxShadow='0 1px 3px rgba(0,0,0,0.06)'; }}>
                  <div style={{ width: '100%', aspectRatio: '3/4', background: '#f1f5f9', overflow: 'hidden' }}>
                    {v.fotoUrl
                      ? <img src={v.fotoUrl} alt={v.nome} style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top' }} />
                      : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32, fontWeight: 700, color: '#94a3b8' }}>{exib(v).split(' ').map(n=>n[0]).join('').slice(0,2)}</div>
                    }
                  </div>
                  <div style={{ padding: '10px' }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: '#0f172a', lineHeight: 1.3, marginBottom: 3 }}>{exibCurto(v)}</div>
                    <div style={{ fontSize: 10, color: '#94a3b8', marginBottom: 8 }}>{v.partido}</div>
                    <button onClick={() => adicionarNaFila(v)} style={{ width: '100%', padding: '5px 0', fontSize: 11, fontWeight: 600, border: '1px solid #3b82f6', borderRadius: 6, background: '#eff6ff', color: '#2563eb', cursor: 'pointer' }}>+ Adicionar</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Fila */}
        {abaFila === 'fila' && (
          <div style={{ flex: 1, overflowY: 'auto', padding: 16 }}>
            {filaOradores.length === 0 ? (
              <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: 13, padding: 40 }}>Nenhum orador na fila.<br />Vá em "Vereadores" para adicionar.</div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {filaOradores.map((item, idx) => (
                  <div key={item.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px', background: 'white', border: '1px solid #e2e8f0', borderRadius: 10 }}>
                    <span style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', width: 20, textAlign: 'center' }}>{idx+1}</span>
                    {item.foto ? <img src={item.foto} alt={item.nome} style={{ width: 56, height: 56, borderRadius: 8, objectFit: 'cover', objectPosition: 'center top' }} /> : <div style={{ width: 56, height: 56, borderRadius: 8, background: '#e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, fontWeight: 700, color: '#94a3b8' }}>{item.nome?.split(' ').map(n=>n[0]).join('').slice(0,2)}</div>}
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: '#0f172a' }}>{exibPorNome(vereadores, item.nome)}</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 3 }}>
                        <input type="number" value={item.tempo} min={1} max={30} onChange={e => atualizarTempoFila(item.id, Number(e.target.value))} style={{ width: 44, padding: '2px 4px', fontSize: 11, border: '1px solid #e2e8f0', borderRadius: 4, textAlign: 'center' }} />
                        <span style={{ fontSize: 11, color: '#94a3b8' }}>min</span>
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 4 }}>
                      <button onClick={() => moverFila(item.id, 'up')} disabled={idx===0} style={{ padding: '4px 6px', border: '1px solid #e2e8f0', borderRadius: 5, background: 'white', cursor: idx===0?'default':'pointer', opacity: idx===0?0.4:1 }}>▲</button>
                      <button onClick={() => moverFila(item.id, 'down')} disabled={idx===filaOradores.length-1} style={{ padding: '4px 6px', border: '1px solid #e2e8f0', borderRadius: 5, background: 'white', cursor: idx===filaOradores.length-1?'default':'pointer', opacity: idx===filaOradores.length-1?0.4:1 }}>▼</button>
                      <button onClick={() => iniciarDaFila(item)} style={{ padding: '4px 10px', border: 'none', borderRadius: 5, background: '#16a34a', color: 'white', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>Iniciar</button>
                      <button onClick={() => removerDaFila(item.id)} style={{ padding: '4px 8px', border: '1px solid #fee2e2', borderRadius: 5, background: '#fff', color: '#dc2626', fontSize: 11, cursor: 'pointer' }}>✕</button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Externo */}
        {abaFila === 'externo' && (
          <div style={{ flex: 1, padding: 24, display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4, display: 'block' }}>Nome do orador</label>
              <input value={nomeExterno} onChange={e => setNomeExterno(e.target.value)} placeholder="Nome completo" style={{ width: '100%', padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: 8, fontSize: 13, boxSizing: 'border-box' }} />
            </div>
            <div>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4, display: 'block' }}>Tempo (minutos)</label>
              <input type="number" value={tempoExterno} onChange={e => setTempoExterno(Number(e.target.value))} min={1} max={30} style={{ width: 80, padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: 8, fontSize: 13 }} />
            </div>
            <button onClick={adicionarExternoNaFila} disabled={!nomeExterno.trim()} style={{ padding: '10px 20px', background: '#0f172a', color: 'white', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', alignSelf: 'flex-start', opacity: !nomeExterno.trim() ? 0.5 : 1 }}>+ Adicionar à fila</button>
          </div>
        )}
      </div>

      {/* Coluna direita - cronômetro ativo */}
      <div style={{ width: 280, flexShrink: 0, padding: 20, display: 'flex', flexDirection: 'column', gap: 14, background: '#f8fafc', borderLeft: '1px solid #e2e8f0' }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Orador Atual</div>
        {cronometroAtivo ? (
          <>
            <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: 12, overflow: 'hidden' }}>
              {cronometroFoto && <img src={cronometroFoto} alt={cronometroNome} style={{ width: '100%', aspectRatio: '3/4', objectFit: 'cover', objectPosition: 'center top', display: 'block' }} />}
              <div style={{ padding: '12px 14px' }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#0f172a' }}>{exibPorNome(vereadores, cronometroNome)}</div>
              </div>
            </div>
            <div style={{ fontFamily: 'monospace', fontSize: 48, fontWeight: 900, color: tempoRestante > 60 ? '#16a34a' : tempoRestante > 30 ? '#d97706' : '#dc2626', textAlign: 'center', lineHeight: 1 }}>{fmt(tempoRestante)}</div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {[30, 60, 180].map(s => <button key={s} onClick={() => adicionarTempo(s)} style={{ flex: 1, padding: '5px 0', fontSize: 11, fontWeight: 600, border: '1px solid #e2e8f0', borderRadius: 6, background: 'white', cursor: 'pointer' }}>+{s>=60?`${s/60}min`:`${s}s`}</button>)}
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={pausarCronometro} style={{ flex: 1, padding: '8px 0', fontSize: 12, fontWeight: 700, border: '1px solid #e2e8f0', borderRadius: 8, background: 'white', cursor: 'pointer' }}>{cronometroPausado ? '▶ Retomar' : '⏸ Pausar'}</button>
              <button onClick={pararCronometro} style={{ flex: 1, padding: '8px 0', fontSize: 12, fontWeight: 700, border: 'none', borderRadius: 8, background: '#dc2626', color: 'white', cursor: 'pointer' }}>⏹ Parar</button>
            </div>
          </>
        ) : (
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 10, color: '#94a3b8', textAlign: 'center' }}>
            <Mic size={36} color="#cbd5e1" />
            <div style={{ fontSize: 13 }}>Nenhum orador em fala.<br />Adicione à fila e inicie.</div>
          </div>
        )}
      </div>
    </div>
  );
}

function ConteudoPresenca({ presencas, loadingPresenca, buscarPresenca }) {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
        <h2 style={{ fontSize: '1.2rem', fontWeight: 800, color: '#0f172a', margin: 0 }}>Controle de Presença</h2>
        <button onClick={buscarPresenca} style={{ background: '#2563eb', border: 'none', color: 'white', padding: '6px 12px', borderRadius: 8, cursor: 'pointer', fontSize: '0.936rem', fontWeight: 700 }}>🔄 Atualizar</button>
      </div>
      <div style={{ display: 'flex', gap: 10, marginBottom: 14 }}>
        {[
          { label: 'Presentes', valor: presencas.filter(v => v.presente).length, bg: '#dcfce7', cor: '#16a34a' },
          { label: 'Ausentes',  valor: presencas.filter(v => !v.presente).length, bg: '#fee2e2', cor: '#dc2626' },
          { label: 'Total',     valor: presencas.length, bg: '#dbeafe', cor: '#1d4ed8' },
        ].map((item, i) => (
          <div key={i} style={{ flex: 1, background: item.bg, borderRadius: 10, padding: '12px 16px', textAlign: 'center' }}>
            <div style={{ fontSize: '1.92rem', fontWeight: 800, color: item.cor }}>{item.valor}</div>
            <div style={{ fontSize: '0.864rem', fontWeight: 600, color: item.cor }}>{item.label}</div>
          </div>
        ))}
      </div>
      {loadingPresenca ? <div style={{ textAlign: 'center', padding: 40 }}><div className="spinner" /></div>
      : <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          {presencas.map(v => (
            <div key={v.id} style={{ background: v.presente ? '#f0fdf4' : '#fff5f5', border: `1px solid ${v.presente ? '#bbf7d0' : '#fecaca'}`, borderRadius: 10, padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 36, height: 36, borderRadius: '50%', overflow: 'hidden', flexShrink: 0, background: v.presente ? '#16a34a' : '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '0.9rem', fontWeight: 700 }}>
                {v.fotoUrl ? <img src={v.fotoUrl} alt={v.nome} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : exib(v).split(' ').map(n => n[0]).slice(0,2).join('')}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ fontWeight: 700, fontSize: '0.984rem', color: '#0f172a', margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{exib(v)}</p>
                <p style={{ fontSize: '0.84rem', color: '#64748b', margin: 0 }}>{v.partido}</p>
              </div>
              <span style={{ fontSize: '1.32rem' }}>{v.presente ? '✅' : '❌'}</span>
            </div>
          ))}
        </div>
      }
    </div>
  );
}

function ConteudoOrdem({ pautas, isPresidente, onReordenar, onRetirar }) {
  const statusCfg = {
    APROVADA:   { label: 'Aprovada',    bg: '#dcfce7', cor: '#15803d' },
    REPROVADA:  { label: 'Reprovada',   bg: '#fee2e2', cor: '#b91c1c' },
    EM_VOTACAO: { label: 'Em Votação',  bg: '#fee2e2', cor: '#dc2626' },
    RETIRADA:   { label: 'Retirada',    bg: '#f3f4f6', cor: '#6b7280' },
    PENDENTE:   { label: 'Pendente',    bg: '#f1f5f9', cor: '#64748b' },
  };

  const corBorda = (status) => {
    if (status === 'APROVADA') return '#16a34a';
    if (status === 'REPROVADA' || status === 'EM_VOTACAO') return '#dc2626';
    if (status === 'RETIRADA') return '#94a3b8';
    return '#e2e8f0';
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
        <h2 style={{ fontSize: '1.2rem', fontWeight: 800, color: '#0f172a', margin: 0 }}>Ordem do Dia</h2>
        {isPresidente && <span style={{ fontSize: '0.84rem', color: '#94a3b8', fontWeight: 600 }}>Use ▲▼ para reordenar as pautas pendentes</span>}
      </div>
      {pautas.length === 0
        ? <div style={{ background: 'white', borderRadius: 12, padding: 40, textAlign: 'center', border: '1px solid #e2e8f0' }}>
            <ClipboardList size={36} style={{ margin: '0 auto 12px', display: 'block', color: '#cbd5e1' }} />
            <p style={{ color: '#64748b' }}>Nenhuma pauta cadastrada.</p>
          </div>
        : pautas.map((p, i) => {
          const cfg = statusCfg[p.status] || statusCfg.PENDENTE;
          const podeMover = isPresidente && p.status === 'PENDENTE';
          const podeRetirar = isPresidente && (p.status === 'PENDENTE');
          return (
            <div key={p.id} style={{ background: p.status === 'RETIRADA' ? '#fafafa' : 'white', borderRadius: 10, padding: '12px 18px', marginBottom: 8, border: '1px solid #e2e8f0', borderLeft: `4px solid ${corBorda(p.status)}`, display: 'flex', alignItems: 'center', gap: 14, opacity: p.status === 'RETIRADA' ? 0.6 : 1 }}>

              {/* Número */}
              <div style={{ width: 28, height: 28, borderRadius: 6, background: p.status === 'EM_VOTACAO' ? '#dc2626' : '#1a2d5a', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <span style={{ color: 'white', fontSize: '0.84rem', fontWeight: 800 }}>{String(i+1).padStart(2,'0')}</span>
              </div>

              {/* Título + tipo */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ fontWeight: 700, fontSize: '1.02rem', color: '#0f172a', margin: '0 0 2px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textDecoration: p.status === 'RETIRADA' ? 'line-through' : 'none' }}>
                  {p.numero} — {p.titulo}
                </p>
                <p style={{ fontSize: '0.816rem', color: '#94a3b8', margin: 0 }}>{p.tipo?.replace('_', ' ')}</p>
              </div>

              {/* Status */}
              <span style={{ background: cfg.bg, color: cfg.cor, fontSize: '0.78rem', fontWeight: 700, padding: '3px 10px', borderRadius: 6, flexShrink: 0, letterSpacing: 0.3 }}>
                {cfg.label}
              </span>

              {/* >>> PLENARIUM:ANEXO_ORDEM botao */}
              {/* Documento da matéria. As pautas da sessão em andamento chegam
                  com projetoId; as do histórico, com projeto.id. */}
              {(p.projetoId || p.projeto?.id) && (
                <button
                  onClick={() => abrirAnexo(p.projetoId || p.projeto.id)}
                  title="Abrir o documento da matéria"
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 5, height: 26, padding: '0 10px', borderRadius: 6, border: '1px solid #bfdbfe', background: '#eff6ff', color: '#1d4ed8', cursor: 'pointer', fontSize: '0.78rem', fontWeight: 700, whiteSpace: 'nowrap', flexShrink: 0 }}
                >
                  <FileText size={13} /> Ver anexo
                </button>
              )}

              {/* Controles presidente */}
              {isPresidente && (
                <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
                  {podeMover && (
                    <>
                      <button onClick={() => onReordenar(i, 'cima')} disabled={i === 0}
                        style={{ width: 26, height: 26, borderRadius: 6, border: '1px solid #e2e8f0', background: i === 0 ? '#f8fafc' : 'white', color: i === 0 ? '#cbd5e1' : '#475569', cursor: i === 0 ? 'default' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.84rem', fontWeight: 700 }}>
                        ▲
                      </button>
                      <button onClick={() => onReordenar(i, 'baixo')} disabled={i === pautas.length - 1}
                        style={{ width: 26, height: 26, borderRadius: 6, border: '1px solid #e2e8f0', background: i === pautas.length - 1 ? '#f8fafc' : 'white', color: i === pautas.length - 1 ? '#cbd5e1' : '#475569', cursor: i === pautas.length - 1 ? 'default' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.84rem', fontWeight: 700 }}>
                        ▼
                      </button>
                    </>
                  )}
                  {podeRetirar && (
                    <button onClick={() => onRetirar(p)}
                      style={{ height: 26, padding: '0 8px', borderRadius: 6, border: '1px solid #fecaca', background: '#fff5f5', color: '#dc2626', cursor: 'pointer', fontSize: '0.78rem', fontWeight: 700, whiteSpace: 'nowrap' }}>
                      Retirar
                    </button>
                  )}
                </div>
              )}
            </div>
          );
        })
      }
    </div>
  );
}

// >>> PLENARIUM:ANEXO_ORDEM abrirAnexo
// Busca o anexo só no clique: o PDF fica em base64 no banco e não deve
// trafegar junto da listagem de sessões.
//
// A aba e aberta JA, dentro do clique. Aberta depois do download, o
// navegador do tablet trata como propaganda e bloqueia.
//
// O PDF vira Blob em vez de ir inteiro dentro do endereco (data:...).
// O leitor de PDF do Chrome recusa "data:" em iframe -- a aba ficava
// em branco. Blob e o caminho que a tela do admin ja usa.
async function abrirAnexo(projetoId) {
  const aba = window.open('', '_blank');
  if (!aba) {
    toast.error('O navegador bloqueou a nova aba. Permita pop-ups para este site.');
    return;
  }
  try {
    aba.document.title = 'Carregando documento...';
    aba.document.body.innerHTML =
      '<p style="font-family:sans-serif;padding:24px;color:#475569">Carregando o documento...</p>';
  } catch (e) { /* alguns navegadores nao deixam escrever; segue igual */ }

  try {
    const r = await axios.get(`/api/projetos/${projetoId}/anexo`);
    const dados = r.data?.arquivo;
    if (!dados) {
      try { aba.close(); } catch (e) {}
      toast.error('Este projeto não tem anexo.');
      return;
    }
    if (!dados.startsWith('data:')) {
      aba.location.href = dados;
      return;
    }
    const [cabecalho, corpo] = dados.split(',');
    const tipo = (cabecalho.match(/:(.*?);/) || [])[1] || 'application/pdf';
    const bin = atob(corpo);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    aba.location.href = URL.createObjectURL(new Blob([bytes], { type: tipo }));
  } catch (e) {
    try { aba.close(); } catch (e2) {}
    toast.error(e?.response?.data?.error || 'Não foi possível abrir o anexo.');
  }
}
// <<< PLENARIUM:ANEXO_ORDEM abrirAnexo

function ConteudoHistorico({ historico, loadingHistorico, usuario, expandidoSessao, setExpandidoSessao }) {
  const [filtroSituacao, setFiltroSituacao] = useState('TODAS');

  // Lê o horário em UTC: é assim que a data foi cadastrada. Converter para o
  // fuso do navegador mostrava 05:00 numa sessão marcada para as 09:00.
  const dataHora = (d) => {
    if (!d) return '';
    const x = new Date(d);
    const p = (n) => String(n).padStart(2, '0');
    return p(x.getUTCDate()) + '/' + p(x.getUTCMonth() + 1) + '/' + x.getUTCFullYear()
      + ' às ' + p(x.getUTCHours()) + ':' + p(x.getUTCMinutes());
  };

  const situacao = (s) => {
    if (s.status === 'ENCERRADA') return { texto: 'Encerrada', cor: '#94a3b8', bg: '#f1f5f9' };
    if (s.status === 'EM_ANDAMENTO') return { texto: 'Em andamento', cor: '#15803d', bg: '#dcfce7' };
    return { texto: 'Agendada', cor: '#1d4ed8', bg: '#eff6ff' };
  };

  const lista = (historico || []).filter(s => {
    if (filtroSituacao === 'TODAS') return true;
    if (filtroSituacao === 'AGENDADA') return s.status !== 'ENCERRADA' && s.status !== 'EM_ANDAMENTO';
    return s.status === filtroSituacao;
  });

  const totalVotosGeral = (historico || []).reduce((acc, s) => acc + (s.pautas?.filter(p => p.votos?.some(v => v.vereadorId === usuario?.id)).length || 0), 0);
  const totalPautas = (historico || []).reduce((acc, s) => acc + (s.pautas?.length || 0), 0);

  const FILTROS = [
    { id: 'TODAS', label: 'Todas' },
    { id: 'AGENDADA', label: 'Agendadas' },
    { id: 'EM_ANDAMENTO', label: 'Em andamento' },
    { id: 'ENCERRADA', label: 'Encerradas' }
  ];

  return (
    <div>
      <div style={{ marginBottom: 14 }}>
        <h2 style={{ fontSize: '1.2rem', fontWeight: 800, color: '#0f172a', margin: '0 0 2px' }}>Sessões</h2>
        <p style={{ fontSize: '0.864rem', color: '#94a3b8', margin: 0 }}>
          {(historico || []).length} sessão(ões) · {totalPautas} matéria(s) · {totalVotosGeral} voto(s) seu(s) registrado(s)
        </p>
      </div>

      <div style={{ display: 'flex', gap: 5, marginBottom: 14, flexWrap: 'wrap' }}>
        {FILTROS.map(f => (
          <button
            key={f.id}
            onClick={() => setFiltroSituacao(f.id)}
            style={{
              padding: '4px 12px', borderRadius: 999, cursor: 'pointer',
              border: '1px solid ' + (filtroSituacao === f.id ? '#2563eb' : '#e2e8f0'),
              background: filtroSituacao === f.id ? '#2563eb' : 'white',
              color: filtroSituacao === f.id ? 'white' : '#64748b',
              fontSize: '0.84rem', fontWeight: 600
            }}
          >
            {f.label}
          </button>
        ))}
      </div>

      {loadingHistorico
        ? <div style={{ textAlign: 'center', padding: 40 }}><div className="spinner" /></div>
        : lista.length === 0
          ? <div style={{ background: 'white', borderRadius: 12, padding: 40, textAlign: 'center', border: '1px solid #e2e8f0' }}>
              <History size={36} style={{ margin: '0 auto 12px', display: 'block', color: '#cbd5e1' }} />
              <p style={{ color: '#64748b', margin: 0 }}>Nenhuma sessão nesta situação.</p>
            </div>
          : lista.map(s => {
              const st = situacao(s);
              const totalVotos = s.pautas?.filter(p => p.votos?.some(v => v.vereadorId === usuario?.id)).length || 0;
              const isExp = expandidoSessao === s.id;
              const encerrada = s.status === 'ENCERRADA';
              return (
                <div key={s.id} style={{ background: 'white', borderRadius: 12, border: '1px solid #e2e8f0', marginBottom: 10, overflow: 'hidden' }}>
                  <div
                    onClick={() => setExpandidoSessao(isExp ? null : s.id)}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '13px 16px', borderBottom: isExp ? '1px solid #f1f5f9' : 'none', cursor: 'pointer', userSelect: 'none' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 11, minWidth: 0 }}>
                      <div style={{ width: 3, height: 34, borderRadius: 2, background: st.cor, flexShrink: 0 }} />
                      <div style={{ minWidth: 0 }}>
                        <p style={{ fontSize: '1.032rem', fontWeight: 700, color: '#0f172a', margin: '0 0 3px' }}>{s.titulo}</p>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 7, flexWrap: 'wrap' }}>
                          <span style={{ fontSize: '0.792rem', fontWeight: 700, color: st.cor, background: st.bg, padding: '2px 8px', borderRadius: 999 }}>{st.texto}</span>
                          <span style={{ fontSize: '0.84rem', color: '#94a3b8' }}>{dataHora(s.data)}</span>
                          <span style={{ fontSize: '0.84rem', color: '#94a3b8' }}>· {s.pautas?.length || 0} matéria(s)</span>
                        </div>
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
                      {totalVotos > 0 && (
                        <span style={{ fontSize: '0.816rem', fontWeight: 600, color: '#15803d', background: '#dcfce7', padding: '2px 10px', borderRadius: 999 }}>
                          {totalVotos} voto(s)
                        </span>
                      )}
                      {isExp ? <ChevronUp size={15} color="#94a3b8" /> : <ChevronDown size={15} color="#94a3b8" />}
                    </div>
                  </div>

                  {isExp && (!s.pautas || s.pautas.length === 0) && (
                    <div style={{ padding: '18px 16px', textAlign: 'center', color: '#94a3b8', fontSize: '0.936rem' }}>
                      Nenhuma matéria cadastrada nesta sessão.
                    </div>
                  )}

                  {isExp && s.pautas?.map((p, idx) => {
                    const mv = p.votos?.find(v => v.vereadorId === usuario?.id);
                    const sim = p.votos?.filter(v => v.opcao === 'SIM').length || 0;
                    const nao = p.votos?.filter(v => v.opcao === 'NAO').length || 0;
                    const abs = p.votos?.filter(v => v.opcao === 'ABSTENCAO').length || 0;
                    const aprovada = p.status === 'APROVADA';
                    const reprovada = p.status === 'REPROVADA';
                    const retirada = p.status === 'RETIRADA';
                    const pendente = !aprovada && !reprovada && !retirada;
                    const barCor = aprovada ? '#16a34a' : reprovada ? '#dc2626' : pendente ? '#3b82f6' : '#94a3b8';
                    const resultadoBg = aprovada ? '#dcfce7' : reprovada ? '#fee2e2' : pendente ? '#eff6ff' : '#f1f5f9';
                    const resultadoCor = aprovada ? '#15803d' : reprovada ? '#b91c1c' : pendente ? '#1d4ed8' : '#64748b';
                    const resultadoLabel = aprovada ? 'Aprovada' : reprovada ? 'Reprovada' : retirada ? 'Retirada' : 'Aguardando votação';
                    const votoBg = mv?.opcao === 'SIM' ? '#dcfce7' : mv?.opcao === 'NAO' ? '#fee2e2' : mv?.opcao === 'ABSTENCAO' ? '#fef9c3' : '#f1f5f9';
                    const votoCor = mv?.opcao === 'SIM' ? '#15803d' : mv?.opcao === 'NAO' ? '#b91c1c' : mv?.opcao === 'ABSTENCAO' ? '#92400e' : '#94a3b8';
                    // Sem voto numa sessão ainda não encerrada não significa falta:
                    // a matéria simplesmente ainda não foi votada.
                    const votoLabel = mv?.opcao === 'SIM' ? 'Sim'
                      : mv?.opcao === 'NAO' ? 'Não'
                      : mv?.opcao === 'ABSTENCAO' ? 'Abstenção'
                      : encerrada ? 'Não registrado' : '—';
                    return (
                      <div key={p.id} style={{ display: 'flex', gap: 0, padding: '13px 16px', borderBottom: idx < s.pautas.length - 1 ? '1px solid #f8fafc' : 'none' }}>
                        <div style={{ width: 3, alignSelf: 'stretch', background: barCor, flexShrink: 0, marginRight: 14, borderRadius: 2 }} />
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <p style={{ fontSize: '0.816rem', color: '#94a3b8', margin: '0 0 3px', fontWeight: 600 }}>{p.numero} · {TIPO_LABEL[p.tipo] || p.tipo}</p>
                          <p style={{ fontSize: '1.176rem', fontWeight: 700, color: '#0f172a', margin: '0 0 6px', lineHeight: 1.35 }}>{p.titulo}</p>

                          {p.projeto?.id && (
                            <button
                              onClick={(e) => { e.stopPropagation(); abrirAnexo(p.projeto.id); }}
                              style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1d4ed8', borderRadius: 8, padding: '7px 14px', fontSize: '0.94rem', fontWeight: 700, cursor: 'pointer', marginBottom: 8 }}
                            >
                              <FileText size={15} /> Ver anexo
                            </button>
                          )}
                          <div style={{ display: 'flex', alignItems: 'center', gap: 7, flexWrap: 'wrap' }}>
                            <span style={{ fontSize: '0.816rem', fontWeight: 600, color: resultadoCor, background: resultadoBg, padding: '2px 8px', borderRadius: 4 }}>{resultadoLabel}</span>
                            {p.votacaoSecreta && (
                              <span style={{ fontSize: '0.816rem', fontWeight: 600, color: '#7c3aed', background: '#ede9fe', padding: '2px 8px', borderRadius: 4 }}>Votação secreta</span>
                            )}
                            {(sim + nao + abs) > 0 && (
                              <span style={{ fontSize: '0.816rem', color: '#94a3b8' }}>SIM {sim} · NÃO {nao} · ABST {abs}</span>
                            )}
                          </div>
                          <VotosNominais votos={p.votos} secreta={p.votacaoSecreta} /> {/* PLENARIUM:CARDS */}
                        </div>
                        <div style={{ flexShrink: 0, textAlign: 'right', paddingLeft: 14 }}>
                          <p style={{ fontSize: '0.756rem', color: '#94a3b8', margin: '0 0 4px' }}>Meu voto</p>
                          <span style={{ fontSize: '0.864rem', fontWeight: 600, color: votoCor, background: votoBg, padding: '3px 10px', borderRadius: 4 }}>{votoLabel}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })
      }
    </div>
  );
}

function ConteudoProjetos({ meusProjetos, loadingProjetos, filtroProjeto, setFiltroProjeto, projetosFiltrados, expandidoProjeto, setExpandidoProjeto, setAba }) {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <h2 style={{ fontSize: '1.2rem', fontWeight: 800, color: '#0f172a', margin: 0 }}>Meus Projetos</h2>
        <button onClick={() => setAba('requerimento')} style={{ background: '#2563eb', border: 'none', color: 'white', padding: '7px 12px', borderRadius: 8, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 5, fontSize: '0.936rem', fontWeight: 700 }}><Plus size={13} /> Novo</button>
      </div>
      <div style={{ display: 'flex', gap: 5, marginBottom: 12, flexWrap: 'wrap' }}>
        {['TODOS','EM_TRAMITACAO','APROVADO','REPROVADO','ARQUIVADO'].map(f => (
          <button key={f} onClick={() => setFiltroProjeto(f)} style={{ padding: '4px 10px', borderRadius: 999, border: `1px solid ${filtroProjeto === f ? '#2563eb' : '#e2e8f0'}`, cursor: 'pointer', fontSize: '0.84rem', fontWeight: 600, background: filtroProjeto === f ? '#2563eb' : 'white', color: filtroProjeto === f ? 'white' : '#64748b' }}>
            {f === 'TODOS' ? 'Todos' : STATUS_LABEL[f]}
          </button>
        ))}
      </div>
      {loadingProjetos ? <div style={{ textAlign: 'center', padding: 40 }}><div className="spinner" /></div>
      : projetosFiltrados.length === 0
        ? <div style={{ background: 'white', borderRadius: 12, padding: 40, textAlign: 'center', border: '1px solid #e2e8f0' }}><FileText size={36} style={{ margin: '0 auto 12px', display: 'block', color: '#cbd5e1' }} /><p style={{ color: '#64748b', marginBottom: 12 }}>Nenhum projeto encontrado.</p><button onClick={() => setAba('requerimento')} style={{ background: '#2563eb', border: 'none', color: 'white', padding: '8px 16px', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: '0.96rem' }}>+ Enviar primeiro requerimento</button></div>
        : projetosFiltrados.map(p => (
          <div key={p.id} style={{ background: 'white', borderRadius: 12, padding: 14, marginBottom: 10, border: '1px solid #e2e8f0', borderLeft: `4px solid ${STATUS_COR[p.status] || '#94a3b8'}` }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', gap: 5, marginBottom: 5 }}>
                  <span style={{ padding: '2px 7px', borderRadius: 999, fontSize: '0.78rem', fontWeight: 600, background: STATUS_BG[p.status], color: STATUS_COR[p.status] }}>{STATUS_LABEL[p.status]}</span>
                  <span style={{ padding: '2px 7px', borderRadius: 999, fontSize: '0.78rem', background: '#f1f5f9', color: '#64748b' }}>{TIPO_LABEL[p.tipo]}</span>
                </div>
                <p style={{ fontWeight: 700, fontSize: '1.02rem', color: '#0f172a', margin: '0 0 2px' }}>{p.numero} — {p.ementa}</p>
                <p style={{ fontSize: '0.78rem', color: '#94a3b8', margin: 0 }}>Enviado em {format(new Date(p.criadoEm), "dd/MM/yyyy", { locale: ptBR })}</p>
              </div>
              <button onClick={() => setExpandidoProjeto(expandidoProjeto === p.id ? null : p.id)} style={{ background: '#f1f5f9', border: '1px solid #e2e8f0', color: '#64748b', padding: '5px 9px', borderRadius: 8, cursor: 'pointer', flexShrink: 0 }}>
                {expandidoProjeto === p.id ? <ChevronUp size={13} /> : <ChevronDown size={13} />}
              </button>
            </div>
            {expandidoProjeto === p.id && (
              <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px solid #f1f5f9' }}>
                {p.descricao && (
                  <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '10px 12px', marginBottom: 10 }}>
                    <p style={{ fontSize: '0.78rem', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 4 }}>Descrição completa</p>
                    <p style={{ fontSize: '0.936rem', color: '#0f172a', lineHeight: 1.5, margin: 0 }}>{p.descricao}</p>
                  </div>
                )}
                {p.arquivoUrl && (
                  <button
                    onClick={() => {
                      if (p.arquivoUrl.startsWith('data:')) {
                        const arr = p.arquivoUrl.split(',');
                        const mime = arr[0].match(/:(.*?);/)[1];
                        const bstr = atob(arr[1]);
                        let n = bstr.length;
                        const u8arr = new Uint8Array(n);
                        while (n--) u8arr[n] = bstr.charCodeAt(n);
                        const blob = new Blob([u8arr], { type: mime });
                        window.open(URL.createObjectURL(blob), '_blank');
                      } else {
                        window.open(p.arquivoUrl, '_blank');
                      }
                    }}
                    style={{ display: 'inline-flex', alignItems: 'center', gap: 5, background: '#dbeafe', border: '1px solid #bfdbfe', color: '#1d4ed8', padding: '6px 12px', borderRadius: 8, fontSize: '0.9rem', fontWeight: 600, cursor: 'pointer', marginBottom: 10 }}
                  >
                    📎 Abrir arquivo anexado
                  </button>
                )}
                {p.tramitacoes?.length > 0 && p.tramitacoes.map(t => (
                  <div key={t.id} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                    <div style={{ width: 24, height: 24, borderRadius: '50%', background: '#dbeafe', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.84rem', flexShrink: 0 }}>{ETAPA_LABEL[t.etapa]?.icon}</div>
                    <div>
                      <strong style={{ fontSize: '0.9rem', color: '#0f172a' }}>{ETAPA_LABEL[t.etapa]?.label}</strong>
                      <span style={{ fontSize: '0.816rem', color: '#94a3b8', marginLeft: 5 }}>— {t.usuarioNome}</span>
                      <p style={{ fontSize: '0.864rem', color: '#64748b', margin: '2px 0' }}>{t.descricao}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))
      }
    </div>
  );
}

function ConteudoRequerimento({ formReq, setFormReq, enviarRequerimento, salvandoReq, setAba }) {
  return (
    <div>
      <h2 style={{ fontSize: '1.2rem', fontWeight: 800, color: '#0f172a', margin: '0 0 14px' }}>Novo Requerimento</h2>
      <div style={{ background: 'white', borderRadius: 16, padding: 22, border: '1px solid #e2e8f0' }}>
        <form onSubmit={enviarRequerimento}>
          <div className="form-group">
            <label className="form-label">Tipo *</label>
            <select className="form-input form-select" value={formReq.tipo} onChange={e => setFormReq({ ...formReq, tipo: e.target.value })} required>
              {TIPOS_VEREADOR.map(t => <option key={t} value={t}>{TIPO_LABEL[t]}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Ementa *</label>
            <input className="form-input" value={formReq.ementa} onChange={e => setFormReq({ ...formReq, ementa: e.target.value })} required placeholder="Descrição resumida" />
          </div>
          <div className="form-group">
            <label className="form-label">Descrição completa</label>
            <textarea className="form-input" rows={3} value={formReq.descricao} onChange={e => setFormReq({ ...formReq, descricao: e.target.value })} style={{ resize: 'vertical' }} />
          </div>
          <div className="form-group">
            <label className="form-label">Anexar documento (PDF, máx. 5MB)</label>
            <input type="file" accept=".pdf,image/*" className="form-input" onChange={(e) => {
              const file = e.target.files[0]; if (!file) return;
              if (file.size > 5 * 1024 * 1024) { toast.error('Máximo 5MB!'); return; }
              const reader = new FileReader(); reader.onload = () => setFormReq({ ...formReq, arquivoUrl: reader.result }); reader.readAsDataURL(file);
            }} />
            {formReq.arquivoUrl && <p style={{ fontSize: '0.864rem', color: '#16a34a', marginTop: 4 }}>✅ Arquivo anexado</p>}
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <button type="button" onClick={() => setAba('votacao')} className="btn btn-secondary" style={{ flex: 1 }}>Cancelar</button>
            <button type="submit" disabled={salvandoReq} className="btn btn-primary" style={{ flex: 1 }}>{salvandoReq ? 'Enviando...' : '📤 Enviar'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

const OVERLAY_STYLE = {
  position: 'fixed', inset: 0,
  background: 'rgba(15,23,42,0.55)', backdropFilter: 'blur(2px)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  zIndex: 2000,
  paddingBottom: 'calc(68px + env(safe-area-inset-bottom))',
  paddingTop: 16, paddingLeft: 16, paddingRight: 16,
  boxSizing: 'border-box',
};

function TelaSemSessao({ historico = [], meusProjetos = [], usuario = null, fotoExibida = '' }) {
  const [agora, setAgora] = React.useState(new Date());
  React.useEffect(() => {
    const t = setInterval(() => setAgora(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const h = agora.getHours().toString().padStart(2,'0');
  const m = agora.getMinutes().toString().padStart(2,'0');
  const s = agora.getSeconds().toString().padStart(2,'0');
  const dias = ['Domingo','Segunda-feira','Terça-feira','Quarta-feira','Quinta-feira','Sexta-feira','Sábado'];
  const meses = ['janeiro','fevereiro','março','abril','maio','junho','julho','agosto','setembro','outubro','novembro','dezembro'];
  const dataExtenso = `${dias[agora.getDay()]}, ${agora.getDate()} de ${meses[agora.getMonth()]} de ${agora.getFullYear()}`;
  const totalVotacoes = historico.reduce((acc, s) => acc + (s.pautas?.length || 0), 0);
  const projetosEmTramitacao = meusProjetos.filter(p => p.status === 'PENDENTE' || p.status === 'EM_TRAMITACAO').length;
  const ultimaSessao = [...historico].filter(s => s.status === 'ENCERRADA').sort((a, b) => new Date(b.data) - new Date(a.data))[0] || null;
  const proximaSessao = [...historico].filter(s => s.status === 'AGENDADA').sort((a, b) => new Date(a.data) - new Date(b.data))[0] || null;

  const cardStyle = { background: 'white', border: '1px solid #e2e8f0', borderRadius: 12, padding: '16px 20px' };
  const labelStyle = { fontSize: 10, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 6 };

  const iniciais = usuario?.nome?.split(' ').map(n => n[0]).slice(0,2).join('') || '?';
  const cargoLabel = tratamento(usuario);

  return (
    <div className="pv-sem-sessao" style={{ flex: 1, padding: '20px 24px', background: '#f1f5f9', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 16 }}>

      {/* Foto do vereador em destaque */}
      <div className="pv-ss-perfil" style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: 12, padding: '20px 24px', display: 'flex', alignItems: 'center', gap: 20 }}>
        <div className="pv-ss-foto" style={{ width: 90, height: 90, borderRadius: 12, overflow: 'hidden', border: '2px solid #e2e8f0', flexShrink: 0, background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {fotoExibida
            ? <img src={fotoExibida} alt={usuario?.nome} style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top' }} />
            : <span style={{ fontSize: 32, fontWeight: 700, color: '#94a3b8' }}>{iniciais}</span>
          }
        </div>
        <div>
          <div style={{ fontSize: 11, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 4 }}>Bem-vindo(a)</div>
          <div className="pv-ss-nome" style={{ fontSize: 20, fontWeight: 700, color: '#0f172a' }}>{exib(usuario) || 'Vereador'}</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
            <span style={{ fontSize: 11, background: '#eff6ff', color: '#1d4ed8', padding: '2px 10px', borderRadius: 20, fontWeight: 600 }}>{cargoLabel}</span>
            {usuario?.partido && <span style={{ fontSize: 11, color: '#94a3b8' }}>{usuario.partido}</span>}
          </div>
          <div className="pv-ss-sub" style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>Acompanhamento em tempo real das atividades legislativas.</div>
        </div>
      </div>

      {/* Stat cards */}
      <div className="pv-ss-cards" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12 }}>
        {[
          { icon: <Calendar size={18} color={"currentColor"} />, label: 'SESSÕES REALIZADAS', value: historico.length, sub: 'Total registradas', color: '#4338ca', bg: '#e0e7ff' },
          { icon: <Vote size={18} color={"currentColor"} />, label: 'VOTAÇÕES', value: totalVotacoes, sub: 'Total de votações', color: '#0369a1', bg: '#e0f2fe' },
          /* >>> PLENARIUM:LAYOUT_VEREADOR cartao de projetos removido a pedido */
        ].map((c, i) => (
          <div key={i} className="pv-ss-card" style={{ ...cardStyle, display: 'flex', alignItems: 'center', gap: 14 }}>
            <div className="pv-ss-card-icone" style={{ width: 44, height: 44, borderRadius: 10, background: c.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, flexShrink: 0 }}>{c.icon}</div>
            <div>
              <div style={{ fontSize: 10, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{c.label}</div>
              <div className="pv-ss-card-valor" style={{ fontSize: 26, fontWeight: 700, color: c.color, lineHeight: 1.1 }}>{c.value}</div>
              <div className="pv-ss-card-sub" style={{ fontSize: 11, color: '#94a3b8' }}>{c.sub}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Linha do meio */}
      <div className="pv-ss-linha" style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 12 }}>

        {/* Situação da sessão */}
        <div className="pv-ss-situacao" style={{ ...cardStyle, background: '#1e3a5f', border: 'none', display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ fontSize: 10, fontWeight: 600, color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>SITUAÇÃO DA SESSÃO</div>
          <div className="pv-ss-sit-corpo" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, padding: '8px 0' }}>
            <div className="pv-ss-sit-icone" style={{ width: 44, height: 44, borderRadius: '50%', background: 'rgba(255,255,255,0.08)', border: '1.5px solid rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,0.85)' }}><Calendar size={20} /></div>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', letterSpacing: 1, textAlign: 'center' }}>NENHUMA SESSÃO EM ANDAMENTO</div>
            <div className="pv-ss-relogio" style={{ fontFamily: 'monospace', fontSize: 32, fontWeight: 600, color: '#60a5fa', letterSpacing: 2 }}>{h}:{m}:{s}</div>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>{dataExtenso}</div>
          </div>
        </div>

        {/* Última sessão */}
        

        {/* Próxima sessão */}
        
      </div>

    </div>
  );
}

function Modais({ confirmando, setConfirmando, confirmarVoto, votando, pautaVoto, modalCronometro, setModalCronometro, vereadores, vereadorSelecionado, setVereadorSelecionado, nomeOrador, setNomeOrador, tempoOrador, setTempoOrador, iniciarCronometro, filaOradores, abaFila, setAbaFila, nomeExterno, setNomeExterno, tempoExterno, setTempoExterno, adicionarNaFila, adicionarExternoNaFila, removerDaFila, moverFila, atualizarTempoFila, iniciarDaFila, modalSenha, setModalSenha, senhaAtual, setSenhaAtual, novaSenha, setNovaSenha, confirmarSenha, setConfirmarSenha, alterarSenha, salvandoSenha, modalFoto, setModalFoto, novaFoto, setNovaFoto, fotoExibida, alterarFoto, salvandoFoto }) {
  return (
    <>
      {/* PLENARIUM:CARDS v10 -- confirmacao de voto */}
      <ConfirmarVoto opcao={confirmando} pauta={pautaVoto} votando={votando} onCancelar={() => setConfirmando(null)} onConfirmar={confirmarVoto} />
      {modalCronometro && (
        <div className="modal-overlay" style={OVERLAY_STYLE}>
          <div className="modal" style={{ maxWidth: 'calc(100vw - 100px)', width: 'calc(100vw - 100px)', maxHeight: '90vh', padding: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            <div className="modal-header" style={{ padding: '12px 16px', borderBottom: '0.5px solid #e2e8f0' }}>
              <h2 className="modal-title"><Timer size={16} /> Cronômetro — Uso da Palavra</h2>
              <button className="btn-modal-close" onClick={() => setModalCronometro(false)}><X size={18} /></button>
            </div>
            <div style={{ display: 'flex', gap: 8, padding: '10px 16px', borderBottom: '0.5px solid #e2e8f0', background: '#f8fafc' }}>
              {[
                { id: 'vereadores', label: 'Vereadores' },
                { id: 'fila', label: 'Fila de oradores' + (filaOradores.length > 0 ? ` (${filaOradores.length})` : '') },
                { id: 'externo', label: '+ Orador externo' },
              ].map(tab => (
                <button key={tab.id} onClick={() => setAbaFila(tab.id)} style={{ padding: '5px 14px', borderRadius: 20, fontSize: 12, fontWeight: 500, border: '0.5px solid', borderColor: abaFila === tab.id ? '#0f172a' : '#e2e8f0', background: abaFila === tab.id ? '#0f172a' : 'white', color: abaFila === tab.id ? 'white' : '#64748b', cursor: 'pointer' }}>
                  {tab.label}
                </button>
              ))}
            </div>
            {abaFila === 'vereadores' && (
              <div style={{ padding: 16, flex: 1, overflowY: 'auto' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 12 }}>
                  {vereadores.map(v => (
                    <div key={v.id} style={{ border: '1px solid #e2e8f0', borderRadius: 12, overflow: 'hidden', background: 'white', boxShadow: '0 1px 3px rgba(0,0,0,0.06)', transition: 'all 0.15s', cursor: 'pointer' }}
                      onMouseEnter={e => { e.currentTarget.style.borderColor='#3b82f6'; e.currentTarget.style.boxShadow='0 4px 12px rgba(59,130,246,0.15)'; }}
                      onMouseLeave={e => { e.currentTarget.style.borderColor='#e2e8f0'; e.currentTarget.style.boxShadow='0 1px 3px rgba(0,0,0,0.06)'; }}>
                      {/* Foto */}
                      <div style={{ width: '100%', aspectRatio: '3/4', background: '#f1f5f9', overflow: 'hidden', position: 'relative' }}>
                        {v.fotoUrl
                          ? <img src={v.fotoUrl} alt={v.nome} style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top' }} />
                          : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32, fontWeight: 700, color: '#94a3b8' }}>{exib(v).split(' ').map(n=>n[0]).join('').slice(0,2)}</div>
                        }
                      </div>
                      {/* Info */}
                      <div style={{ padding: '10px 10px 10px' }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: '#0f172a', lineHeight: 1.3, marginBottom: 3 }}>{exibCurto(v)}</div>
                        <div style={{ fontSize: 10, color: '#94a3b8', marginBottom: 8 }}>{v.partido}</div>
                        <button onClick={() => adicionarNaFila(v)} style={{ width: '100%', padding: '5px 0', fontSize: 11, fontWeight: 600, border: '1px solid #3b82f6', borderRadius: 6, background: '#eff6ff', color: '#2563eb', cursor: 'pointer' }}>+ Adicionar</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {abaFila === 'fila' && (
              <div style={{ flex: 1, overflowY: 'auto' }}>
                {filaOradores.length === 0 ? (
                  <div style={{ padding: 32, textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>Nenhum orador na fila.<br />Vá em "Vereadores" para adicionar.</div>
                ) : (
                  <div style={{ padding: 12, display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {filaOradores.map((item, i) => (
                      <div key={item.id} style={{ background: i === 0 ? '#F0FDF4' : 'white', border: `0.5px solid ${i === 0 ? '#86EFAC' : '#e2e8f0'}`, borderRadius: 10, padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ width: 22, height: 22, borderRadius: '50%', background: i === 0 ? '#185FA5' : '#e2e8f0', color: i === 0 ? 'white' : '#64748b', fontSize: 11, fontWeight: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{i + 1}</div>
                        {item.foto ? <img src={item.foto} alt={item.nome} style={{ width: 38, height: 38, borderRadius: '50%', objectFit: 'cover', border: '1.5px solid #e2e8f0', flexShrink: 0 }} /> : <div style={{ width: 38, height: 38, borderRadius: '50%', background: '#E6F1FB', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 500, color: '#0C447C', flexShrink: 0 }}>{item.nome[0]}</div>}
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 13, fontWeight: 500, color: '#0f172a' }}>{item.nome}</div>
                          <div style={{ fontSize: 11, color: '#94a3b8', display: 'flex', alignItems: 'center', gap: 6 }}>
                            {item.partido} · <input type="number" min="1" max="60" value={item.tempo} onChange={e => atualizarTempoFila(item.id, e.target.value)} style={{ width: 42, fontSize: 11, padding: '1px 4px', border: '0.5px solid #e2e8f0', borderRadius: 4, textAlign: 'center' }} /> min
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                          <button onClick={() => moverFila(item.id, -1)} disabled={i === 0} style={{ padding: '2px 7px', fontSize: 12, border: '0.5px solid #e2e8f0', borderRadius: 5, background: 'white', cursor: i === 0 ? 'not-allowed' : 'pointer', color: '#64748b', opacity: i === 0 ? 0.3 : 1 }}>↑</button>
                          <button onClick={() => moverFila(item.id, 1)} disabled={i === filaOradores.length - 1} style={{ padding: '2px 7px', fontSize: 12, border: '0.5px solid #e2e8f0', borderRadius: 5, background: 'white', cursor: i === filaOradores.length - 1 ? 'not-allowed' : 'pointer', color: '#64748b', opacity: i === filaOradores.length - 1 ? 0.3 : 1 }}>↓</button>
                          {i === 0 && <button onClick={() => iniciarDaFila(item)} style={{ padding: '4px 12px', fontSize: 12, background: '#185FA5', color: '#E6F1FB', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 500, whiteSpace: 'nowrap' }}>▶ Iniciar fala</button>}
                          <button onClick={() => removerDaFila(item.id)} style={{ padding: '4px 8px', fontSize: 12, background: '#FEF2F2', color: '#B91C1C', border: '0.5px solid #FECACA', borderRadius: 6, cursor: 'pointer' }}>✕</button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                <div style={{ padding: '10px 16px', borderTop: '0.5px solid #e2e8f0', background: '#f8fafc' }}>
                  <p style={{ fontSize: 11, color: '#94a3b8', margin: '0 0 6px' }}>Ou inicie diretamente sem fila:</p>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <select className="form-input form-select" style={{ flex: 1, fontSize: 12 }} value={vereadorSelecionado} onChange={e => { setVereadorSelecionado(e.target.value); const v = vereadores.find(x => x.id === e.target.value); setNomeOrador(v ? v.nome : ''); }}>
                      <option value="">— Selecionar vereador —</option>
                      {vereadores.map(v => <option key={v.id} value={v.id}>{v.nome}</option>)}
                    </select>
                    <input className="form-input" style={{ flex: 1, fontSize: 12 }} value={nomeOrador} onChange={e => setNomeOrador(e.target.value)} placeholder="Nome do orador" />
                    <select className="form-input form-select" style={{ width: 80, fontSize: 12 }} value={tempoOrador} onChange={e => setTempoOrador(Number(e.target.value))}>
                      {[1,2,3,5,10].map(t => <option key={t} value={t}>{t} min</option>)}
                    </select>
                    <button className="btn btn-primary" style={{ whiteSpace: 'nowrap', fontSize: 12 }} onClick={iniciarCronometro}>▶ Iniciar</button>
                  </div>
                </div>
              </div>
            )}
            {abaFila === 'externo' && (
              <div style={{ padding: 20 }}>
                <div className="form-group">
                  <label className="form-label">Nome do orador externo</label>
                  <input className="form-input" value={nomeExterno} onChange={e => setNomeExterno(e.target.value)} placeholder="Nome completo do orador" />
                </div>
                <div className="form-group">
                  <label className="form-label">Tempo de fala</label>
                  <div style={{ display: 'flex', gap: 8 }}>
                    {[1,2,3,5,10].map(t => (
                      <button key={t} onClick={() => setTempoExterno(t)} style={{ flex: 1, padding: '8px 0', borderRadius: 8, border: `2px solid ${tempoExterno === t ? '#2563eb' : '#e2e8f0'}`, background: tempoExterno === t ? '#2563eb' : 'white', color: tempoExterno === t ? 'white' : '#64748b', fontWeight: 700, cursor: 'pointer', fontSize: 13 }}>{t}min</button>
                    ))}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                  <button className="btn btn-secondary" onClick={() => setModalCronometro(false)}>Cancelar</button>
                  <button className="btn btn-primary" onClick={adicionarExternoNaFila}>+ Adicionar à fila</button>
                  <button className="btn btn-primary" style={{ background: '#185FA5' }} onClick={() => { if (!nomeExterno.trim()) { toast.error('Informe o nome.'); return; } setNomeOrador(nomeExterno.trim()); setTempoOrador(tempoExterno); setVereadorSelecionado(''); iniciarCronometro(); setNomeExterno(''); }}>▶ Iniciar agora</button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {modalSenha && (
        <div className="modal-overlay" style={OVERLAY_STYLE}>
          <div className="modal">
            <div className="modal-header">
              <h2 className="modal-title"><KeyRound size={16} /> Alterar Senha</h2>
              <button className="btn-modal-close" onClick={() => setModalSenha(false)}><X size={18} /></button>
            </div>
            <form onSubmit={alterarSenha}>
              <div className="form-group"><label className="form-label">Senha Atual</label><input type="password" className="form-input" value={senhaAtual} onChange={e => setSenhaAtual(e.target.value)} required /></div>
              <div className="form-group"><label className="form-label">Nova Senha</label><input type="password" className="form-input" value={novaSenha} onChange={e => setNovaSenha(e.target.value)} required /></div>
              <div className="form-group"><label className="form-label">Confirmar Nova Senha</label><input type="password" className="form-input" value={confirmarSenha} onChange={e => setConfirmarSenha(e.target.value)} required /></div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setModalSenha(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={salvandoSenha}>{salvandoSenha ? 'Salvando...' : 'Salvar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
      {modalFoto && (
        <div className="modal-overlay" style={OVERLAY_STYLE}>
          <div className="modal">
            <div className="modal-header">
              <h2 className="modal-title"><Camera size={16} /> Alterar Foto</h2>
              <button className="btn-modal-close" onClick={() => { setModalFoto(false); setNovaFoto(''); }}><X size={18} /></button>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
              <div style={{ width: 90, height: 90, borderRadius: '50%', overflow: 'hidden', border: '3px solid #2563eb', background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {novaFoto || fotoExibida ? <img src={novaFoto || fotoExibida} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <Camera size={32} color="#94a3b8" />}
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Selecionar nova foto (máx. 2MB)</label>
              <input type="file" accept="image/*" className="form-input" onChange={(e) => {
                const file = e.target.files[0]; if (!file) return;
                if (file.size > 2 * 1024 * 1024) { toast.error('Máximo 2MB!'); return; }
                const reader = new FileReader(); reader.onload = () => setNovaFoto(reader.result); reader.readAsDataURL(file);
              }} />
            </div>
            <div className="modal-actions">
              <button type="button" className="btn btn-secondary" onClick={() => { setModalFoto(false); setNovaFoto(''); }}>Cancelar</button>
              <button onClick={alterarFoto} disabled={salvandoFoto || !novaFoto} className="btn btn-primary">{salvandoFoto ? 'Salvando...' : 'Salvar Foto'}</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
